/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "pwNi");
/******/ })
/************************************************************************/
/******/ ({

/***/ "/QC5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "subscribers", function() { return subscribers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getCurrentUrl", function() { return getCurrentUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "route", function() { return route; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Router", function() { return Router; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Route", function() { return Route; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Link", function() { return Link; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("KM04");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact__);


var EMPTY$1 = {};

function assign(obj, props) {
	// eslint-disable-next-line guard-for-in
	for (var i in props) {
		obj[i] = props[i];
	}
	return obj;
}

function exec(url, route, opts) {
	var reg = /(?:\?([^#]*))?(#.*)?$/,
	    c = url.match(reg),
	    matches = {},
	    ret;
	if (c && c[1]) {
		var p = c[1].split('&');
		for (var i = 0; i < p.length; i++) {
			var r = p[i].split('=');
			matches[decodeURIComponent(r[0])] = decodeURIComponent(r.slice(1).join('='));
		}
	}
	url = segmentize(url.replace(reg, ''));
	route = segmentize(route || '');
	var max = Math.max(url.length, route.length);
	for (var i$1 = 0; i$1 < max; i$1++) {
		if (route[i$1] && route[i$1].charAt(0) === ':') {
			var param = route[i$1].replace(/(^\:|[+*?]+$)/g, ''),
			    flags = (route[i$1].match(/[+*?]+$/) || EMPTY$1)[0] || '',
			    plus = ~flags.indexOf('+'),
			    star = ~flags.indexOf('*'),
			    val = url[i$1] || '';
			if (!val && !star && (flags.indexOf('?') < 0 || plus)) {
				ret = false;
				break;
			}
			matches[param] = decodeURIComponent(val);
			if (plus || star) {
				matches[param] = url.slice(i$1).map(decodeURIComponent).join('/');
				break;
			}
		} else if (route[i$1] !== url[i$1]) {
			ret = false;
			break;
		}
	}
	if (opts.default !== true && ret === false) {
		return false;
	}
	return matches;
}

function pathRankSort(a, b) {
	return a.rank < b.rank ? 1 : a.rank > b.rank ? -1 : a.index - b.index;
}

// filter out VNodes without attributes (which are unrankeable), and add `index`/`rank` properties to be used in sorting.
function prepareVNodeForRanking(vnode, index) {
	vnode.index = index;
	vnode.rank = rankChild(vnode);
	return vnode.attributes;
}

function segmentize(url) {
	return url.replace(/(^\/+|\/+$)/g, '').split('/');
}

function rankSegment(segment) {
	return segment.charAt(0) == ':' ? 1 + '*+?'.indexOf(segment.charAt(segment.length - 1)) || 4 : 5;
}

function rank(path) {
	return segmentize(path).map(rankSegment).join('');
}

function rankChild(vnode) {
	return vnode.attributes.default ? 0 : rank(vnode.attributes.path);
}

var customHistory = null;

var ROUTERS = [];

var subscribers = [];

var EMPTY = {};

function isPreactElement(node) {
	return node.__preactattr_ != null || typeof Symbol !== 'undefined' && node[Symbol.for('preactattr')] != null;
}

function setUrl(url, type) {
	if (type === void 0) type = 'push';

	if (customHistory && customHistory[type]) {
		customHistory[type](url);
	} else if (typeof history !== 'undefined' && history[type + 'State']) {
		history[type + 'State'](null, null, url);
	}
}

function getCurrentUrl() {
	var url;
	if (customHistory && customHistory.location) {
		url = customHistory.location;
	} else if (customHistory && customHistory.getCurrentLocation) {
		url = customHistory.getCurrentLocation();
	} else {
		url = typeof location !== 'undefined' ? location : EMPTY;
	}
	return "" + (url.pathname || '') + (url.search || '');
}

function route(url, replace) {
	if (replace === void 0) replace = false;

	if (typeof url !== 'string' && url.url) {
		replace = url.replace;
		url = url.url;
	}

	// only push URL into history if we can handle it
	if (canRoute(url)) {
		setUrl(url, replace ? 'replace' : 'push');
	}

	return routeTo(url);
}

/** Check if the given URL can be handled by any router instances. */
function canRoute(url) {
	for (var i = ROUTERS.length; i--;) {
		if (ROUTERS[i].canRoute(url)) {
			return true;
		}
	}
	return false;
}

/** Tell all router instances to handle the given URL.  */
function routeTo(url) {
	var didRoute = false;
	for (var i = 0; i < ROUTERS.length; i++) {
		if (ROUTERS[i].routeTo(url) === true) {
			didRoute = true;
		}
	}
	for (var i$1 = subscribers.length; i$1--;) {
		subscribers[i$1](url);
	}
	return didRoute;
}

function routeFromLink(node) {
	// only valid elements
	if (!node || !node.getAttribute) {
		return;
	}

	var href = node.getAttribute('href'),
	    target = node.getAttribute('target');

	// ignore links with targets and non-path URLs
	if (!href || !href.match(/^\//g) || target && !target.match(/^_?self$/i)) {
		return;
	}

	// attempt to route, if no match simply cede control to browser
	return route(href);
}

function handleLinkClick(e) {
	if (e.button == 0) {
		routeFromLink(e.currentTarget || e.target || this);
		return prevent(e);
	}
}

function prevent(e) {
	if (e) {
		if (e.stopImmediatePropagation) {
			e.stopImmediatePropagation();
		}
		if (e.stopPropagation) {
			e.stopPropagation();
		}
		e.preventDefault();
	}
	return false;
}

function delegateLinkHandler(e) {
	// ignore events the browser takes care of already:
	if (e.ctrlKey || e.metaKey || e.altKey || e.shiftKey || e.button !== 0) {
		return;
	}

	var t = e.target;
	do {
		if (String(t.nodeName).toUpperCase() === 'A' && t.getAttribute('href') && isPreactElement(t)) {
			if (t.hasAttribute('native')) {
				return;
			}
			// if link is handled by the router, prevent browser defaults
			if (routeFromLink(t)) {
				return prevent(e);
			}
		}
	} while (t = t.parentNode);
}

var eventListenersInitialized = false;

function initEventListeners() {
	if (eventListenersInitialized) {
		return;
	}

	if (typeof addEventListener === 'function') {
		if (!customHistory) {
			addEventListener('popstate', function () {
				routeTo(getCurrentUrl());
			});
		}
		addEventListener('click', delegateLinkHandler);
	}
	eventListenersInitialized = true;
}

var Router = function (Component$$1) {
	function Router(props) {
		Component$$1.call(this, props);
		if (props.history) {
			customHistory = props.history;
		}

		this.state = {
			url: props.url || getCurrentUrl()
		};

		initEventListeners();
	}

	if (Component$$1) Router.__proto__ = Component$$1;
	Router.prototype = Object.create(Component$$1 && Component$$1.prototype);
	Router.prototype.constructor = Router;

	Router.prototype.shouldComponentUpdate = function shouldComponentUpdate(props) {
		if (props.static !== true) {
			return true;
		}
		return props.url !== this.props.url || props.onChange !== this.props.onChange;
	};

	/** Check if the given URL can be matched against any children */
	Router.prototype.canRoute = function canRoute(url) {
		return this.getMatchingChildren(this.props.children, url, false).length > 0;
	};

	/** Re-render children with a new URL to match against. */
	Router.prototype.routeTo = function routeTo(url) {
		this._didRoute = false;
		this.setState({ url: url });

		// if we're in the middle of an update, don't synchronously re-route.
		if (this.updating) {
			return this.canRoute(url);
		}

		this.forceUpdate();
		return this._didRoute;
	};

	Router.prototype.componentWillMount = function componentWillMount() {
		ROUTERS.push(this);
		this.updating = true;
	};

	Router.prototype.componentDidMount = function componentDidMount() {
		var this$1 = this;

		if (customHistory) {
			this.unlisten = customHistory.listen(function (location) {
				this$1.routeTo("" + (location.pathname || '') + (location.search || ''));
			});
		}
		this.updating = false;
	};

	Router.prototype.componentWillUnmount = function componentWillUnmount() {
		if (typeof this.unlisten === 'function') {
			this.unlisten();
		}
		ROUTERS.splice(ROUTERS.indexOf(this), 1);
	};

	Router.prototype.componentWillUpdate = function componentWillUpdate() {
		this.updating = true;
	};

	Router.prototype.componentDidUpdate = function componentDidUpdate() {
		this.updating = false;
	};

	Router.prototype.getMatchingChildren = function getMatchingChildren(children, url, invoke) {
		return children.filter(prepareVNodeForRanking).sort(pathRankSort).map(function (vnode) {
			var matches = exec(url, vnode.attributes.path, vnode.attributes);
			if (matches) {
				if (invoke !== false) {
					var newProps = { url: url, matches: matches };
					assign(newProps, matches);
					delete newProps.ref;
					delete newProps.key;
					return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["cloneElement"])(vnode, newProps);
				}
				return vnode;
			}
		}).filter(Boolean);
	};

	Router.prototype.render = function render(ref, ref$1) {
		var children = ref.children;
		var onChange = ref.onChange;
		var url = ref$1.url;

		var active = this.getMatchingChildren(children, url, true);

		var current = active[0] || null;
		this._didRoute = !!current;

		var previous = this.previousUrl;
		if (url !== previous) {
			this.previousUrl = url;
			if (typeof onChange === 'function') {
				onChange({
					router: this,
					url: url,
					previous: previous,
					active: active,
					current: current
				});
			}
		}

		return current;
	};

	return Router;
}(__WEBPACK_IMPORTED_MODULE_0_preact__["Component"]);

var Link = function Link(props) {
	return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('a', assign({ onClick: handleLinkClick }, props));
};

var Route = function Route(props) {
	return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(props.component, props);
};

Router.subscribers = subscribers;
Router.getCurrentUrl = getCurrentUrl;
Router.route = route;
Router.Router = Router;
Router.Route = Route;
Router.Link = Link;

/* harmony default export */ __webpack_exports__["default"] = (Router);
//# sourceMappingURL=preact-router.es.js.map

/***/ }),

/***/ "3O1A":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__("eW0v"), __webpack_require__("eW0v"), __webpack_require__("uVvu"), __webpack_require__("uKgs"), __webpack_require__("Zgq/")], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports !== "undefined") {
        factory(exports, require('react'), require('react-dom'), require('../SAlertContent'), require('./s-alert-store'), require('./s-alert-tools'));
    } else {
        var mod = {
            exports: {}
        };
        factory(mod.exports, global.react, global.reactDom, global.SAlertContent, global.sAlertStore, global.sAlertTools);
        global.sAlertDataPrep = mod.exports;
    }
})(this, function (exports, _react, _reactDom, _SAlertContent, _sAlertStore, _sAlertTools) {
    'use strict';

    Object.defineProperty(exports, "__esModule", {
        value: true
    });

    var _react2 = _interopRequireDefault(_react);

    var _reactDom2 = _interopRequireDefault(_reactDom);

    var _SAlertContent2 = _interopRequireDefault(_SAlertContent);

    var _sAlertStore2 = _interopRequireDefault(_sAlertStore);

    var _sAlertTools2 = _interopRequireDefault(_sAlertTools);

    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }

    var _extends = Object.assign || function (target) {
        for (var i = 1; i < arguments.length; i++) {
            var source = arguments[i];

            for (var key in source) {
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }

        return target;
    };

    var getAlertData = function getAlertData(sAlertPosition, parentComponent) {
        var positionTop = 0;
        var positionBottom = 0;
        var padding = 0;
        var alerts = {};
        var style = void 0;
        var docElement = void 0;
        var sAlertBoxHeight = void 0;
        var positionTypeTop = void 0;
        var positionTypeBottom = void 0;
        var checkFirst = function checkFirst(type, objId) {
            var collectionOfType = sAlertCollection.filter(function (obj) {
                return obj.position === type || sAlertGlobalConfig.position === type;
            });
            return collectionOfType && collectionOfType[0].id === objId;
        };
        var positionFunc = function positionFunc(position, positionType, alert, docElement, sAlertBoxHeight, reactComponent) {
            padding = aStack.spacing || parseInt(getComputedStyle(_reactDom2.default.findDOMNode(reactComponent))[positionType]);
            if (checkFirst(aPosition, alert.id) && aOffset) {
                position = 0;
                position = position + parseInt(aOffset);
            }
            if (checkFirst(aPosition, alert.id) && aStack.spacing) {
                position = position;
            } else {
                position = position + parseInt(padding);
            }
            style = positionType + ': ' + position + 'px;';
            position = position + sAlertBoxHeight;
            return position;
        };

        var sAlertGlobalConfig = _sAlertTools2.default.getGlobalConfig();
        var aStack = void 0;
        var aContentTemplate = void 0;
        var aOffset = void 0;
        var aMessage = void 0;
        var aHtml = void 0;
        var aCustomFields = void 0;
        var aPosition = void 0;
        var preserveContext = void 0;

        var query = {};
        if (sAlertPosition === 'left') {
            query = function query(item) {
                return item.position === 'top-left' || item.position === 'bottom-left' || !item.position && (sAlertGlobalConfig.position === 'top-left' || sAlertGlobalConfig.position === 'bottom-left');
            };
        }
        if (sAlertPosition === 'right') {
            query = function query(item) {
                return item.position === 'top-right' || item.position === 'bottom-right' || !item.position && (sAlertGlobalConfig.position === 'top-right' || sAlertGlobalConfig.position === 'bottom-right');
            };
        }
        if (sAlertPosition === 'full-top') {
            query = function query(item) {
                return item.position === 'top' || !item.position && sAlertGlobalConfig.position === 'top';
            };
        }
        if (sAlertPosition === 'full-bottom') {
            query = function query(item) {
                return item.position === 'bottom' || !item.position && sAlertGlobalConfig.position === 'bottom';
            };
        }

        var currentState = _sAlertStore2.default.getState();
        var sAlertCollection = currentState.slice().filter(query);

        return sAlertCollection.map(function (alert) {
            aStack = sAlertGlobalConfig.stack;
            aContentTemplate = sAlertGlobalConfig.contentTemplate;
            aOffset = _sAlertTools2.default.returnFirstDefined(alert.offset, sAlertGlobalConfig.offset);
            aMessage = _sAlertTools2.default.returnFirstDefined(alert.message, sAlertGlobalConfig.message);
            aHtml = _sAlertTools2.default.returnFirstDefined(alert.html, sAlertGlobalConfig.html);
            aCustomFields = _sAlertTools2.default.returnFirstDefined(alert.customFields, sAlertGlobalConfig.customFields);
            aPosition = _sAlertTools2.default.returnFirstDefined(alert.position, sAlertGlobalConfig.position);
            preserveContext = _sAlertTools2.default.returnFirstDefined(alert.preserveContext, sAlertGlobalConfig.preserveContext);
            positionTypeTop = aPosition && /top/g.test(aPosition);
            positionTypeBottom = aPosition && /bottom/g.test(aPosition);

            if (aStack) {
                // checking alert box height - needed to calculate position
                docElement = document.createElement('div');
                docElement.classList.add('s-alert-box-height');

                // mock element, needed for positions calculations
                var reactElement = _react2.default.createElement(_SAlertContent2.default, {
                    key: _sAlertTools2.default.randomId(),
                    id: _sAlertTools2.default.randomId(),
                    condition: alert.condition,
                    message: aMessage,
                    position: aPosition,
                    effect: alert.effect,
                    boxPosition: alert.boxPosition,
                    beep: false,
                    timeout: 'none',
                    html: aHtml,
                    contentTemplate: aContentTemplate,
                    customFields: aCustomFields
                });

                var reactComponent = void 0;

                if (preserveContext) {
                    reactComponent = _reactDom2.default.unstable_renderSubtreeIntoContainer(parentComponent, reactElement, docElement);
                } else {
                    reactComponent = _reactDom2.default.render(reactElement, docElement);
                }

                document.body.appendChild(docElement);
                sAlertBoxHeight = parseInt(getComputedStyle(_reactDom2.default.findDOMNode(reactComponent))['height']);
                if (positionTypeTop) {
                    positionTop = positionFunc(positionTop, 'top', alert, docElement, sAlertBoxHeight, reactComponent);
                }
                if (positionTypeBottom) {
                    positionBottom = positionFunc(positionBottom, 'bottom', alert, docElement, sAlertBoxHeight, reactComponent);
                }
                var sAlertComputedStyle = getComputedStyle(_reactDom2.default.findDOMNode(reactComponent));
                if (sAlertPosition === 'left') {
                    style = style + 'left: ' + (aStack.spacing || parseInt(sAlertComputedStyle.left)) + 'px;';
                }
                if (sAlertPosition === 'right') {
                    style = style + 'right: ' + (aStack.spacing || parseInt(sAlertComputedStyle.right)) + 'px;';
                }
                alerts = _extends({}, alert, { boxPosition: style });
                _reactDom2.default.unmountComponentAtNode(docElement);
                docElement.parentNode.removeChild(docElement);
            } else if (aOffset && positionTypeTop) {
                alerts = _extends({}, alert, { boxPosition: 'top: ' + parseInt(aOffset) + 'px;' });
            } else if (aOffset && positionTypeBottom) {
                alerts = _extends({}, alert, { boxPosition: 'bottom: ' + parseInt(aOffset) + 'px;' });
            } else {
                alerts = alert;
            }
            return alerts;
        });
    };

    exports.default = getAlertData;
});

/***/ }),

/***/ "5D9O":
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol.for && Symbol.for('react.element') || 0xeac7;

  var isValidElement = function isValidElement(object) {
    return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__("wVGV")();
}

/***/ }),

/***/ "7y3A":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "8/ba":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__("eW0v"), __webpack_require__("uVvu"), __webpack_require__("5D9O"), __webpack_require__("uKgs"), __webpack_require__("Zgq/"), __webpack_require__("3O1A")], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports !== "undefined") {
        factory(exports, require('react'), require('./SAlertContent'), require('prop-types'), require('./s-alert-parts/s-alert-store'), require('./s-alert-parts/s-alert-tools'), require('./s-alert-parts/s-alert-data-prep'));
    } else {
        var mod = {
            exports: {}
        };
        factory(mod.exports, global.react, global.SAlertContent, global.propTypes, global.sAlertStore, global.sAlertTools, global.sAlertDataPrep);
        global.SAlert = mod.exports;
    }
})(this, function (exports, _react, _SAlertContent, _propTypes, _sAlertStore, _sAlertTools, _sAlertDataPrep) {
    'use strict';

    Object.defineProperty(exports, "__esModule", {
        value: true
    });

    var _react2 = _interopRequireDefault(_react);

    var _SAlertContent2 = _interopRequireDefault(_SAlertContent);

    var _propTypes2 = _interopRequireDefault(_propTypes);

    var _sAlertStore2 = _interopRequireDefault(_sAlertStore);

    var _sAlertTools2 = _interopRequireDefault(_sAlertTools);

    var _sAlertDataPrep2 = _interopRequireDefault(_sAlertDataPrep);

    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }

    function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
            throw new TypeError("Cannot call a class as a function");
        }
    }

    var _createClass = function () {
        function defineProperties(target, props) {
            for (var i = 0; i < props.length; i++) {
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor) descriptor.writable = true;
                Object.defineProperty(target, descriptor.key, descriptor);
            }
        }

        return function (Constructor, protoProps, staticProps) {
            if (protoProps) defineProperties(Constructor.prototype, protoProps);
            if (staticProps) defineProperties(Constructor, staticProps);
            return Constructor;
        };
    }();

    function _possibleConstructorReturn(self, call) {
        if (!self) {
            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        }

        return call && (typeof call === "object" || typeof call === "function") ? call : self;
    }

    function _inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) {
            throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
        }

        subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: {
                value: subClass,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
    }

    var _extends = Object.assign || function (target) {
        for (var i = 1; i < arguments.length; i++) {
            var source = arguments[i];

            for (var key in source) {
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }

        return target;
    };

    var insertFunc = function insertFunc(msg, data, condition) {
        var id = _sAlertTools2.default.randomId();
        _sAlertStore2.default.dispatch({
            type: 'INSERT',
            data: _extends({}, data, {
                id: id,
                condition: condition,
                message: msg
            })
        });
        return id;
    };

    var SAlert = function (_React$Component) {
        _inherits(SAlert, _React$Component);

        function SAlert(props) {
            _classCallCheck(this, SAlert);

            var _this = _possibleConstructorReturn(this, (SAlert.__proto__ || Object.getPrototypeOf(SAlert)).call(this, props));

            _this.state = {
                dataRight: [],
                dataLeft: [],
                dataTop: [],
                dataBottom: []
            };
            return _this;
        }

        _createClass(SAlert, [{
            key: 'componentDidMount',
            value: function componentDidMount() {
                var _this2 = this;

                var storeStateLeft = void 0;
                var storeStateRight = void 0;
                var storeStateTop = void 0;
                var storeStateBottom = void 0;

                var addToStoreRight = function addToStoreRight() {
                    requestAnimationFrame(function () {
                        return requestAnimationFrame(function () {
                            var length = void 0;
                            storeStateRight = (0, _sAlertDataPrep2.default)('right', _this2) || [];
                            length = storeStateRight.length;
                            if (_this2.props.stack && _this2.props.stack.limit && length > _this2.props.stack.limit) {
                                var id = storeStateRight[0].id;
                                _sAlertStore2.default.dispatch({ type: 'REMOVE', data: { id: id } });
                                storeStateRight = (0, _sAlertDataPrep2.default)('right', _this2) || [];
                            }
                            _this2.setState({ dataRight: storeStateRight });
                        });
                    });
                };
                this.unsubStoreRight = _sAlertStore2.default.subscribe(addToStoreRight);

                var addToStoreLeft = function addToStoreLeft() {
                    requestAnimationFrame(function () {
                        return requestAnimationFrame(function () {
                            var length = void 0;
                            storeStateLeft = (0, _sAlertDataPrep2.default)('left', _this2) || [];
                            length = storeStateLeft.length;
                            if (_this2.props.stack && _this2.props.stack.limit && length > _this2.props.stack.limit) {
                                var id = storeStateLeft[0].id;
                                _sAlertStore2.default.dispatch({ type: 'REMOVE', data: { id: id } });
                                storeStateLeft = (0, _sAlertDataPrep2.default)('left', _this2) || [];
                            }
                            _this2.setState({ dataLeft: storeStateLeft });
                        });
                    });
                };
                this.unsubStoreLeft = _sAlertStore2.default.subscribe(addToStoreLeft);

                var addToStoreTop = function addToStoreTop() {
                    requestAnimationFrame(function () {
                        return requestAnimationFrame(function () {
                            var length = void 0;
                            storeStateTop = (0, _sAlertDataPrep2.default)('full-top', _this2) || [];
                            length = storeStateTop.length;
                            if (_this2.props.stack && _this2.props.stack.limit && length > _this2.props.stack.limit) {
                                var id = storeStateTop[0].id;
                                _sAlertStore2.default.dispatch({ type: 'REMOVE', data: { id: id } });
                                storeStateTop = (0, _sAlertDataPrep2.default)('full-top', _this2) || [];
                            }
                            _this2.setState({ dataTop: storeStateTop });
                        });
                    });
                };
                this.unsubStoreTop = _sAlertStore2.default.subscribe(addToStoreTop);

                var addToStoreBottom = function addToStoreBottom() {
                    requestAnimationFrame(function () {
                        return requestAnimationFrame(function () {
                            var length = void 0;
                            storeStateBottom = (0, _sAlertDataPrep2.default)('full-bottom', _this2) || [];
                            length = storeStateBottom.length;
                            if (_this2.props.stack && _this2.props.stack.limit && length > _this2.props.stack.limit) {
                                var id = storeStateBottom[0].id;
                                _sAlertStore2.default.dispatch({ type: 'REMOVE', data: { id: id } });
                                storeStateBottom = (0, _sAlertDataPrep2.default)('full-bottom', _this2) || [];
                            }
                            _this2.setState({ dataBottom: storeStateBottom });
                        });
                    });
                };
                this.unsubStoreBottom = _sAlertStore2.default.subscribe(addToStoreBottom);

                // set up global config from global SAlert props
                // only stuff needed for getAlertData
                var globalConfig = {
                    contentTemplate: this.props.contentTemplate,
                    offset: this.props.offset,
                    message: this.props.message,
                    stack: this.props.stack,
                    html: this.props.html,
                    customFields: this.props.customFields,
                    position: this.props.position || 'top-right',
                    preserveContext: this.props.preserveContext || false
                };
                _sAlertTools2.default.setGlobalConfig(globalConfig);
            }
        }, {
            key: 'componentWillUnmount',
            value: function componentWillUnmount() {
                this.unsubStoreTop();
                this.unsubStoreBottom();
                this.unsubStoreLeft();
                this.unsubStoreRight();
            }
        }, {
            key: 'render',
            value: function render() {
                var _this3 = this;

                var mapFunc = function mapFunc(alert, index) {
                    var customKey = 'alert-key-' + alert.id + '-' + alert.position;
                    var id = alert.id;
                    var condition = _sAlertTools2.default.returnFirstDefined(alert.condition, 'info');
                    var message = _sAlertTools2.default.returnFirstDefined(alert.message, _this3.props.message, '');
                    var position = _sAlertTools2.default.returnFirstDefined(alert.position, _this3.props.position, 'top-right');
                    var offset = _sAlertTools2.default.returnFirstDefined(alert.offset, _this3.props.offset, 0);
                    var effect = _sAlertTools2.default.returnFirstDefined(alert.effect, _this3.props.effect);
                    var boxPosition = alert.boxPosition;
                    var beep = _sAlertTools2.default.returnFirstDefined(alert.beep, _this3.props.beep, false);
                    var timeout = _sAlertTools2.default.returnFirstDefined(alert.timeout, _this3.props.timeout, 5000);
                    var html = _sAlertTools2.default.returnFirstDefined(alert.html, _this3.props.html);
                    var onClose = _sAlertTools2.default.returnFirstDefined(alert.onClose, _this3.props.onClose);
                    var onShow = _sAlertTools2.default.returnFirstDefined(alert.onShow, _this3.props.onShow);
                    var customFields = _sAlertTools2.default.returnFirstDefined(alert.customFields, _this3.props.customFields);
                    var contentTemplate = _this3.props.contentTemplate;

                    return _react2.default.createElement(_SAlertContent2.default, {
                        key: customKey,
                        id: id,
                        customFields: customFields,
                        condition: condition,
                        message: message,
                        position: position,
                        effect: effect,
                        boxPosition: boxPosition,
                        beep: beep,
                        timeout: timeout,
                        html: html,
                        onClose: onClose,
                        onShow: onShow,
                        contentTemplate: contentTemplate });
                };
                var sAlertElemsRight = this.state.dataRight.map(mapFunc);
                var sAlertElemsLeft = this.state.dataLeft.map(mapFunc);
                var sAlertElemsTop = this.state.dataTop.map(mapFunc);
                var sAlertElemsBottom = this.state.dataBottom.map(mapFunc);
                return _react2.default.createElement('div', { className: 's-alert-wrapper' }, sAlertElemsRight, sAlertElemsLeft, sAlertElemsTop, sAlertElemsBottom);
            }
        }], [{
            key: 'info',
            value: function info(msg, data) {
                return insertFunc(msg, data, 'info');
            }
        }, {
            key: 'error',
            value: function error(msg, data) {
                return insertFunc(msg, data, 'error');
            }
        }, {
            key: 'warning',
            value: function warning(msg, data) {
                return insertFunc(msg, data, 'warning');
            }
        }, {
            key: 'success',
            value: function success(msg, data) {
                return insertFunc(msg, data, 'success');
            }
        }, {
            key: 'close',
            value: function close(id) {
                _sAlertStore2.default.dispatch({ type: 'REMOVE', data: { id: id } });
            }
        }, {
            key: 'closeAll',
            value: function closeAll() {
                _sAlertStore2.default.dispatch({ type: 'REMOVEALL' });
            }
        }]);

        return SAlert;
    }(_react2.default.Component);

    SAlert.propTypes = {
        message: _propTypes2.default.string,
        position: _propTypes2.default.string,
        offset: _propTypes2.default.number,
        stack: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.object]),
        effect: _propTypes2.default.string,
        beep: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object, _propTypes2.default.bool]),
        timeout: _propTypes2.default.oneOfType([_propTypes2.default.oneOf(['none']), _propTypes2.default.number]),
        html: _propTypes2.default.bool,
        preserveContext: _propTypes2.default.bool,
        onClose: _propTypes2.default.func,
        onShow: _propTypes2.default.func,
        customFields: _propTypes2.default.object,
        contentTemplate: _propTypes2.default.func
    };

    exports.default = SAlert;
});

/***/ }),

/***/ "Asjh":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;

/***/ }),

/***/ "H7e1":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "JkW7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ../node_modules/bootstrap/dist/css/bootstrap.min.css
var bootstrap_min = __webpack_require__("7y3A");
var bootstrap_min_default = /*#__PURE__*/__webpack_require__.n(bootstrap_min);

// EXTERNAL MODULE: ./assets/main.css
var main = __webpack_require__("tBXR");
var main_default = /*#__PURE__*/__webpack_require__.n(main);

// EXTERNAL MODULE: ../node_modules/preact/dist/preact.min.js
var preact_min = __webpack_require__("KM04");
var preact_min_default = /*#__PURE__*/__webpack_require__.n(preact_min);

// EXTERNAL MODULE: ../node_modules/preact-router/dist/preact-router.es.js
var preact_router_es = __webpack_require__("/QC5");

// EXTERNAL MODULE: ../node_modules/unistore/preact.js
var preact = __webpack_require__("o6ac");
var preact_default = /*#__PURE__*/__webpack_require__.n(preact);

// EXTERNAL MODULE: ../node_modules/preact-router/match.js
var match = __webpack_require__("sw5u");
var match_default = /*#__PURE__*/__webpack_require__.n(match);

// EXTERNAL MODULE: ../node_modules/unistore/devtools.js
var unistore_devtools = __webpack_require__("kvQY");
var devtools_default = /*#__PURE__*/__webpack_require__.n(unistore_devtools);

// CONCATENATED MODULE: ../node_modules/unistore/dist/unistore.es.js
function n(n, t) {
  for (var r in t) {
    n[r] = t[r];
  }return n;
}/* harmony default export */ var unistore_es = (function (t) {
  var r = [];function u(n) {
    for (var t = [], u = 0; u < r.length; u++) {
      r[u] === n ? n = null : t.push(r[u]);
    }r = t;
  }function e(u, e, f) {
    t = e ? u : n(n({}, t), u);for (var i = r, o = 0; o < i.length; o++) {
      i[o](t, f);
    }
  }return t = t || {}, { action: function action(n) {
      function r(t) {
        e(t, !1, n);
      }return function () {
        for (var u = arguments, e = [t], f = 0; f < arguments.length; f++) {
          e.push(u[f]);
        }var i = n.apply(this, e);if (null != i) return i.then ? i.then(r) : r(i);
      };
    }, setState: e, subscribe: function subscribe(n) {
      return r.push(n), function () {
        u(n);
      };
    }, unsubscribe: u, getState: function getState() {
      return t;
    } };
});;
//# sourceMappingURL=unistore.es.js.map
// CONCATENATED MODULE: ../node_modules/unissist/dist/unissist.es.js
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/* harmony default export */ var unissist_es = (function (t, e, n) {
  var i = (n = n || {}).version || 1;t.setState({ hydrated: !1 }), Promise.resolve(e.getState()).then(function (e) {
    !e || !e.version && n.migration || e.version < i ? n.migration ? Promise.resolve(n.migration(e, i)).then(function (e) {
      t.setState(_extends({}, e, { hydrated: !0 }));
    }) : t.setState({ hydrated: !0, version: i }) : n.hydration ? t.setState(_extends({}, n.hydration(e), { hydrated: !0 })) : (e.hydrated = !0, t.setState(e));
  });var r,
      a = t.subscribe(function () {
    r || (r = setTimeout(function () {
      var a = t.getState();a.version = a.version || i, e.setState((n.map || Object)(a)), r = null;
    }, n.debounceTime || 100));
  });return function () {
    a(), clearTimeout(r);
  };
});;
//# sourceMappingURL=unissist.es.js.map
// EXTERNAL MODULE: ../node_modules/unissist/integrations/localStorageAdapter.js
var localStorageAdapter = __webpack_require__("e1h4");
var localStorageAdapter_default = /*#__PURE__*/__webpack_require__.n(localStorageAdapter);

// EXTERNAL MODULE: ../node_modules/unfetch/dist/unfetch.es.js
var unfetch_es = __webpack_require__("QAmr");

// EXTERNAL MODULE: ../node_modules/react-s-alert/index.js
var react_s_alert = __webpack_require__("zxAs");
var react_s_alert_default = /*#__PURE__*/__webpack_require__.n(react_s_alert);

// CONCATENATED MODULE: ./util/api.js






var env = "production";

var api_baseUrl = env === 'development' ? 'http://localhost:3003/v1' : 'https://manter-api.herokuapp.com/v1';

function request(url, body, method) {
  return new Promise(function ($return, $error) {
    var expiration, refreshToken, res, result, accessToken, headers, options, response, data, message;

    expiration = store_0.getState().auth.expiration;

    // Reset token
    if (expiration && new Date() > new Date(expiration)) {
      refreshToken = store_0.getState().auth.refreshToken;

      return Promise.resolve(Object(unfetch_es["default"])(api_baseUrl + '/auth/session', {
        method: 'POST',
        body: JSON.stringify({ refreshToken: refreshToken })
      })).then(function ($await_3) {
        try {
          res = $await_3;

          if (!res.ok) {
            store_0.setState(initialState);
            Object(preact_router_es["route"])('/login', true);
          }

          return Promise.resolve(res.json()).then(function ($await_4) {
            try {
              result = $await_4;

              store_0.setState({
                auth: {
                  accessToken: result.accessToken,
                  refreshToken: result.refreshToken,
                  expiration: result.expiration
                }
              });
              return $If_1.call(this);
            } catch ($boundEx) {
              return $error($boundEx);
            }
          }.bind(this), $error);
        } catch ($boundEx) {
          return $error($boundEx);
        }
      }.bind(this), $error);
    }

    function $If_1() {
      accessToken = store_0.getState().auth.accessToken || null;

      headers = {
        'Content-Type': 'application/json'
      };

      if (accessToken) {
        headers.Authorization = 'Bearer ' + accessToken;
      }

      options = {
        method: method,
        headers: headers
      };

      if (method !== 'GET' && method !== 'HEAD') {
        options.body = JSON.stringify(body);
      }

      return Promise.resolve(Object(unfetch_es["default"])('' + api_baseUrl + url, options)).then(function ($await_5) {
        try {
          response = $await_5;

          if (!response.ok) {
            return Promise.resolve(response.json().catch(function () {
              return {};
            })).then(function ($await_6) {
              try {
                data = $await_6;
                message = data.message || 'Something went wrong :(';
                console.log(response);

                if (response.status !== 401) {
                  react_s_alert_default.a.error(message, {
                    position: 'bottom-right'
                  });
                }

                return $error(new Error(message));
              } catch ($boundEx) {
                return $error($boundEx);
              }
            }, $error);
          } else {
            return $return(response.json().catch(function () {
              return {};
            }));
          }
          return $return();
        } catch ($boundEx) {
          return $error($boundEx);
        }
      }.bind(this), $error);
    }

    return $If_1.call(this);
  });
}

var api = {
  get: function get(url) {
    return request(url, null, 'GET');
  },
  del: function del(url) {
    return request(url, {}, 'DELETE');
  },
  put: function put(url, data) {
    return request(url, data, 'PUT');
  },
  patch: function patch(url, data) {
    return request(url, data, 'PATCH');
  },
  post: function post(url, data) {
    return request(url, data, 'POST');
  }
};
// CONCATENATED MODULE: ./store/actions.js
var actions__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





// Create, Find, Get, Remove

var actions_actions = function actions() {
  return {
    /**
     * Authentication
     *
     */
    login: function login(state, email, password) {
      return new Promise(function ($return, $error) {
        var _ref, accessToken, refreshToken, expiration;

        return Promise.resolve(api.post('/auth/sign-in', {
          email: email,
          password: password
        })).then(function ($await_1) {
          try {
            _ref = $await_1, accessToken = _ref.accessToken, refreshToken = _ref.refreshToken, expiration = _ref.expiration;


            Object(preact_router_es["route"])('/');

            return $return({
              auth: actions__extends({}, state.auth, { accessToken: accessToken, refreshToken: refreshToken, email: email, expiration: expiration })
            });
          } catch ($boundEx) {
            return $error($boundEx);
          }
        }, $error);
      });
    },
    register: function register(state, data) {
      return new Promise(function ($return, $error) {
        var _ref2, accessToken, refreshToken, expiration;

        return Promise.resolve(api.post('/auth/sign-up', actions__extends({}, data))).then(function ($await_2) {
          try {
            _ref2 = $await_2, accessToken = _ref2.accessToken, refreshToken = _ref2.refreshToken, expiration = _ref2.expiration;


            // route('/')

            return $return({
              auth: actions__extends({}, state.auth, { accessToken: accessToken, refreshToken: refreshToken, email: data.email, expiration: expiration })
            });
          } catch ($boundEx) {
            return $error($boundEx);
          }
        }, $error);
      });
    },


    logout: function logout() {
      return initialState;
    },

    getMe: function getMe(state) {
      return new Promise(function ($return, $error) {
        var _ref3, email, username;

        return Promise.resolve(api.get('/me/')).then(function ($await_3) {
          try {
            _ref3 = $await_3, email = _ref3.email, username = _ref3.username;


            return $return({ me: actions__extends({}, state.me, { email: email, username: username }) });
          } catch ($boundEx) {
            return $error($boundEx);
          }
        }, $error);
      });
    }
  };
};

/* harmony default export */ var store_actions = (actions_actions);
// CONCATENATED MODULE: ./store/index.js
var store__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };










var initialState = {
  auth: { accessToken: null, email: null, expiration: null, refreshToken: null },
  me: { email: null, username: null }
};

var store_store =  true ? unistore_es(initialState) : devtools(createStore(initialState));

var adapter = localStorageAdapter_default()();

unissist_es(store_store, adapter);

/* harmony default export */ var store_0 = (store_store);

function connect(state, component) {
  return Object(preact["connect"])(state, store_actions)(function (store) {
    return Object(preact_min["h"])(component, store__extends({}, store));
  });
}
// EXTERNAL MODULE: ./assets/icon.svg
var icon = __webpack_require__("VYO7");
var icon_default = /*#__PURE__*/__webpack_require__.n(icon);

// CONCATENATED MODULE: ./components/Header.js






var Header__ref = Object(preact_min["h"])(
  match["Link"],
  { 'class': 'ml-0 mr-4 text-dark no-underline', href: '/' },
  Object(preact_min["h"])('img', { src: icon_default.a, 'class': 'img-fluid', style: 'width: 60px', alt: 'Manter Logo' }),
  ' ',
  Object(preact_min["h"])(
    'span',
    { 'class': 'd-none d-sm-none d-md-inline d-lg-inline d-xl-inline mr-2 brand' },
    'Manter'
  )
);

var Logo = function Logo() {
  return Header__ref;
};

var Header__ref2 = Object(preact_min["h"])(Logo, null);

var Header__ref3 = Object(preact_min["h"])(
  match["Link"],
  { 'class': 'text-dark ml-4', href: '/join' },
  'Sign Up'
);

var _ref4 = Object(preact_min["h"])(
  match["Link"],
  { 'class': 'text-dark ml-4 font-weight-bold', href: '/login' },
  'Log In'
);

var Header_PublicNavbar = function PublicNavbar() {
  return Object(preact_min["h"])(
    'nav',
    { 'class': 'p-3 mx-2 navbar navbar-light bg-white' },
    Header__ref2,
    Object(preact_min["h"])(
      'div',
      { 'class': 'ml-auto' },
      Header__ref3,
      _ref4
    )
  );
};

var _ref5 = Object(preact_min["h"])(Logo, null);

var _ref6 = Object(preact_min["h"])(
  match["Link"],
  { 'class': 'text-dark ml-4', href: '/tags' },
  'Tags'
);

var _ref7 = Object(preact_min["h"])(
  match["Link"],
  { 'class': 'text-dark ml-4', href: '/settings' },
  'Settings'
);

var Header_PrivateNavbar = function PrivateNavbar() {
  return Object(preact_min["h"])(
    'nav',
    { 'class': 'p-3 mx-2 navbar navbar-light bg-white' },
    _ref5,
    Object(preact_min["h"])(
      'div',
      { 'class': 'ml-auto' },
      _ref6,
      _ref7
    )
  );
};

var _ref9 = Object(preact_min["h"])(Header_PrivateNavbar, null);

var _ref10 = Object(preact_min["h"])(Header_PublicNavbar, null);

/* harmony default export */ var Header = (connect('auth', function (_ref8) {
  var auth = _ref8.auth;
  return auth && auth.accessToken ? _ref9 : _ref10;
}));
// EXTERNAL MODULE: ../node_modules/cxs/dist/index.js
var dist = __webpack_require__("d5YJ");
var dist_default = /*#__PURE__*/__webpack_require__.n(dist);

// CONCATENATED MODULE: ./util/index.js
function uuid() {
  return '_' + Math.random().toString(36).substr(2, 9);
}

function stringToDom(str) {
  var parser = new DOMParser();
  return parser.parseFromString(str, 'text/html');
}

function removeProtocol(url) {
  return url.replace(/^https?:\/\//, '');
}

function getFavicon(url) {
  return 'https://www.google.com/s2/favicons?domain=' + url;
}

function ellipsis(str) {
  var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 100;

  return str && str.length > length ? str.substring(0, length) + '...' : str;
}

/**
 * Export functions
 */

function _arrayToCSV(arr) {
  var items = arr;
  // Specify how you want to handle null values here
  var replacer = function replacer(key, value) {
    return value === null ? '' : value;
  };
  var header = Object.keys(items[0]);
  var csv = items.map(function (row) {
    return header.map(function (fieldName) {
      return JSON.stringify(row[fieldName], replacer);
    }).join(',');
  });
  csv.unshift(header.join(','));
  csv = csv.join('\r\n');

  return csv;
}

function _exportData(data, exportName, extension) {
  var dataStr = 'data:text/json;charset=utf-8,' + encodeURIComponent(data);
  var downloadAnchorNode = document.createElement('a');
  downloadAnchorNode.setAttribute('href', dataStr);
  downloadAnchorNode.setAttribute('download', exportName + '.' + extension);
  document.body.appendChild(downloadAnchorNode); // required for firefox
  downloadAnchorNode.click();
  downloadAnchorNode.remove();
}

function downloadObjectAsCSV(exportObj, exportName) {
  var csv = _arrayToCSV(exportObj);

  _exportData(csv, exportName, 'csv');
}

function downloadObjectAsJson(exportObj, exportName) {
  var json = JSON.stringify(exportObj, null, 2);

  return _exportData(json, exportName, 'json');
}
// CONCATENATED MODULE: ./components/Input.js
var Input__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }





var className = dist_default()({
  padding: '0.5rem',
  fontSize: '1rem',
  border: '2px solid #f6f6f6',
  borderRadius: 0,
  backgroundColor: '#f6f6f6',
  color: '#343334',
  '-webkit-appearance': 'none',
  '-moz-appearance': 'none',
  appearance: 'none',
  height: '41px',
  ':disabled': {
    color: '#a8a8a8'
  }
});

var labelClass = dist_default()({
  fontWeight: 'bold',
  display: 'flex',
  lineHeight: '1.3em'
});

var Input__ref2 = Object(preact_min["h"])(
  'span',
  { 'class': 'text-muted font-weight-light font-sm ml-2' },
  'Optional'
);

var Input_Input = function Input(_ref) {
  var _ref$type = _ref.type,
      type = _ref$type === undefined ? 'text' : _ref$type,
      _ref$label = _ref.label,
      label = _ref$label === undefined ? '' : _ref$label,
      value = _ref.value,
      optional = _ref.optional,
      onInput = _ref.onInput,
      _ref$placeholder = _ref.placeholder,
      placeholder = _ref$placeholder === undefined ? '' : _ref$placeholder,
      rest = _objectWithoutProperties(_ref, ['type', 'label', 'value', 'optional', 'onInput', 'placeholder']);

  var id = uuid();

  return Object(preact_min["h"])(
    'div',
    { 'class': rest.containerClass || '' },
    Object(preact_min["h"])(
      'label',
      { 'class': labelClass, 'for': id },
      label,
      ' ',
      !optional ? null : Input__ref2
    ),
    Object(preact_min["h"])('input', Input__extends({
      id: id,
      type: type,
      value: value,
      onInput: onInput,
      placeholder: placeholder
    }, rest, {
      'class': className + ' ' + rest.class
    }))
  );
};

/* harmony default export */ var components_Input = (Input_Input);
// CONCATENATED MODULE: ./components/Form.js
var Form__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



function Form__objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }



var Form_Form = function Form(_ref) {
  var _onSubmit = _ref.onSubmit,
      children = _ref.children,
      rest = Form__objectWithoutProperties(_ref, ['onSubmit', 'children']);

  return Object(preact_min["h"])(
    'form',
    Form__extends({
      onSubmit: function onSubmit(e) {
        e.preventDefault();
        _onSubmit(e);
      }
    }, rest),
    children
  );
};

/* harmony default export */ var components_Form = (Form_Form);
// EXTERNAL MODULE: ../node_modules/cxs/component.js
var cxs_component = __webpack_require__("hVdT");
var component_default = /*#__PURE__*/__webpack_require__.n(cxs_component);

// CONCATENATED MODULE: ./components/OptionsList.js




var Options = component_default()('div')({
  fontSize: '.90em',
  color: 'rgb(171, 171, 171)'
  // fontWeight: 900,
});

var Option = component_default()('span')({
  marginRight: '.5em',
  ':hover': {
    cursor: 'pointer',
    textDecoration: 'underline'
  }
});

var OptionsList_OptionsList = function OptionsList(_ref) {
  var options = _ref.options;

  return Object(preact_min["h"])(
    Options,
    null,
    options.map(function (option, index) {
      return Object(preact_min["h"])(
        Option,
        { key: index, onClick: option.onClick },
        option.name
      );
    })
  );
};

/* harmony default export */ var components_OptionsList = (OptionsList_OptionsList);
// CONCATENATED MODULE: ../node_modules/linkstate/dist/linkstate.es.js
function dlv(obj, key, def, p) {
	p = 0;
	key = key.split ? key.split('.') : key;
	while (obj && p < key.length) {
		obj = obj[key[p++]];
	}
	return obj === undefined ? def : obj;
}

/** Create an Event handler function that sets a given state property.
 *	@param {Component} component	The component whose state should be updated
 *	@param {string} key				A dot-notated key path to update in the component's state
 *	@param {string} eventPath		A dot-notated key path to the value that should be retrieved from the Event or component
 *	@returns {function} linkedStateHandler
 */
function linkState(component, key, eventPath) {
	var path = key.split('.'),
	    cache = component.__lsc || (component.__lsc = {});

	return cache[key + eventPath] || (cache[key + eventPath] = function (e) {
		var t = e && e.target || this,
		    state = {},
		    obj = state,
		    v = typeof eventPath === 'string' ? dlv(e, eventPath) : t.nodeName ? t.type.match(/^che|rad/) ? t.checked : t.value : e,
		    i = 0;
		for (; i < path.length - 1; i++) {
			obj = obj[path[i]] || (obj[path[i]] = !i && component.state[path[i]] || {});
		}
		obj[path[i]] = v;
		component.setState(state);
	});
}

/* harmony default export */ var linkstate_es = (linkState);
//# sourceMappingURL=linkstate.es.js.map
// CONCATENATED MODULE: ./components/BookmarkItem.js
var BookmarkItem__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }














var boderClass = dist_default()({
  borderBottom: '1px solid #e6e5e6'
});

var BookmarkItem__ref = Object(preact_min["h"])(
  'button',
  { 'class': 'text-muted mr-2 btn-link', type: 'submit' },
  'save'
);

var BookmarkItem_BookmarkItem = function (_Component) {
  _inherits(BookmarkItem, _Component);

  function BookmarkItem() {
    var _temp, _this, _ret;

    _classCallCheck(this, BookmarkItem);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
      editing: false,
      initialBookmark: BookmarkItem__extends({}, _this.props.bookmark),
      bookmark: BookmarkItem__extends({}, _this.props.bookmark),
      tags: _this.props.bookmark.tags.map(function (t) {
        return t.name;
      }).join(' ') // #tag #tag2 #tag3
    }, _this.toggleEditMode = function () {
      _this.setState({ editing: !_this.state.editing });
    }, _this.onSave = function () {
      return new Promise(function ($return, $error) {
        var _this$state, bookmark, tags, saved;

        _this$state = _this.state, bookmark = _this$state.bookmark, tags = _this$state.tags;
        return Promise.resolve(api.patch('/bookmark/' + bookmark.id, {
          tags: tags ? tags.split(' ').filter(function (s) {
            return s !== '';
          }) : [],
          title: bookmark.title
        })).then(function ($await_1) {
          try {
            saved = $await_1;

            // Update state
            _this.setState({
              bookmark: BookmarkItem__extends({}, saved),
              initialBookmark: BookmarkItem__extends({}, saved),
              tags: saved.tags.map(function (t) {
                return t.name;
              }).join(' ')
            });

            _this.toggleEditMode();
            return $return();
          } catch ($boundEx) {
            return $error($boundEx);
          }
        }, $error);
      });
    }, _this.onRemove = function () {
      return new Promise(function ($return, $error) {
        var bookmark = _this.state.bookmark;


        if (!confirm('Sure?')) return $return();

        _this.props.removeBookmark(bookmark.id);
        return $return();
      });
    }, _this.onCancelEdit = function () {
      return new Promise(function ($return, $error) {
        var initialBookmark = _this.state.initialBookmark;


        var bookmark = BookmarkItem__extends({}, initialBookmark);
        var tags = initialBookmark.tags.map(function (t) {
          return t.name;
        }).join(' ');

        _this.setState({ bookmark: bookmark, tags: tags });
        _this.toggleEditMode();
        return $return();
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  BookmarkItem.prototype.renderView = function renderView() {
    var _state = this.state,
        tags = _state.tags,
        bookmark = _state.bookmark;


    var tagArray = tags.split(' ').filter(function (s) {
      return s !== '';
    });

    var renderTags = function renderTags() {
      return tagArray.length === 0 ? null : tagArray.map(function (t) {
        return Object(preact_min["h"])(
          preact_router_es["Link"],
          { 'class': 'mx-1 text-muted', href: '/tags/' + t },
          '#',
          t
        );
      });
    };

    return Object(preact_min["h"])(
      'div',
      null,
      Object(preact_min["h"])(
        'div',
        null,
        Object(preact_min["h"])('img', { 'class': 'mr-2', src: getFavicon(bookmark.urlNormalized), alt: 'favicon' }),
        Object(preact_min["h"])(
          'b',
          null,
          bookmark.title
        ),
        Object(preact_min["h"])(
          'span',
          { 'class': 'text-muted ml-2 font-sm' },
          bookmark.relativeTime
        )
      ),
      Object(preact_min["h"])(
        'div',
        { 'class': 'my-1 font-sm' },
        Object(preact_min["h"])(
          'a',
          { href: bookmark.urlNormalized, 'class': 'text-muted', target: '_blank', rel: 'noopener' },
          removeProtocol(bookmark.url)
        ),
        ' ',
        tags ? '~' : '',
        ' ',
        renderTags()
      ),
      Object(preact_min["h"])(
        'button',
        {
          type: 'button',
          'class': 'text-muted mr-2 btn-link font-sm',
          onClick: this.toggleEditMode
        },
        'edit'
      ),
      Object(preact_min["h"])(
        'button',
        { type: 'button', 'class': 'text-muted mr-2 btn-link font-sm', onClick: this.onRemove },
        'remove'
      ),
      ' '
    );
  };

  BookmarkItem.prototype.renderEdit = function renderEdit() {
    var _this2 = this;

    var _state2 = this.state,
        bookmark = _state2.bookmark,
        tags = _state2.tags;


    return Object(preact_min["h"])(
      components_Form,
      { onSubmit: function onSubmit() {
          return _this2.onSave();
        } },
      Object(preact_min["h"])(components_Input, {
        placeholder: 'title',
        value: bookmark.title,
        onInput: linkstate_es(this, 'bookmark.title')
      }),
      Object(preact_min["h"])(components_Input, { placeholder: 'tags', autoFocus: true, value: tags, onInput: linkstate_es(this, 'tags') }),
      Object(preact_min["h"])(
        'div',
        { 'class': 'mt-1 font-sm' },
        BookmarkItem__ref,
        Object(preact_min["h"])(
          'button',
          { type: 'button', 'class': 'text-muted mr-2 btn-link', onClick: this.onCancelEdit },
          'cancel'
        )
      )
    );
  };

  BookmarkItem.prototype.render = function render() {
    var _state3 = this.state,
        editing = _state3.editing,
        bookmark = _state3.bookmark;


    return Object(preact_min["h"])(
      'div',
      { 'class': 'py-4 px-lg-4 px-md-4 px-xl-4 px-sm-2 ' + boderClass },
      editing ? this.renderEdit(bookmark) : this.renderView(bookmark)
    );
  };

  return BookmarkItem;
}(preact_min["Component"]);

/* harmony default export */ var components_BookmarkItem = (connect(null, BookmarkItem_BookmarkItem));
// CONCATENATED MODULE: ./components/BookmarkList.js
var BookmarkList__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



function BookmarkList__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function BookmarkList__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function BookmarkList__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var BookmarkList_BookmarkList = function (_Component) {
  BookmarkList__inherits(BookmarkList, _Component);

  function BookmarkList() {
    var _temp, _this, _ret;

    BookmarkList__classCallCheck(this, BookmarkList);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = BookmarkList__possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.renderBookmark = function (item) {
      return Object(preact_min["h"])(components_BookmarkItem, BookmarkList__extends({ key: item.id, bookmark: item }, _this.props));
    }, _temp), BookmarkList__possibleConstructorReturn(_this, _ret);
  }

  BookmarkList.prototype.render = function render(_ref) {
    var bookmarks = _ref.bookmarks;

    return Object(preact_min["h"])(
      'div',
      null,
      bookmarks.map(this.renderBookmark)
    );
  };

  return BookmarkList;
}(preact_min["Component"]);

/* harmony default export */ var components_BookmarkList = (BookmarkList_BookmarkList);
// CONCATENATED MODULE: ./components/NewBookmark.js
var NewBookmark__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



function NewBookmark__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function NewBookmark__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function NewBookmark__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var inputClass = dist_default()({
  padding: '0.5rem',
  fontSize: '1rem',
  border: '2px solid #f6f6f6',
  borderRadius: 0,
  backgroundColor: '#f6f6f6',
  color: '#343334',
  '-webkit-appearance': 'none',
  '-moz-appearance': 'none',
  appearance: 'none',
  height: '51px',
  width: '100%'
});

var NewBookmark_initialState = {
  loading: false,
  url: ''
};

var NewBookmark_NewBookmark = function (_Component) {
  NewBookmark__inherits(NewBookmark, _Component);

  function NewBookmark() {
    var _temp, _this, _ret;

    NewBookmark__classCallCheck(this, NewBookmark);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = NewBookmark__possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = NewBookmark__extends({}, NewBookmark_initialState), _this.submitUrl = function () {
      return new Promise(function ($return, $error) {
        var url;
        url = _this.state.url;


        _this.setState({ loading: true });

        var $Try_1_Post = function () {
          try {

            if (_this.props.onCreate) {
              return Promise.resolve(_this.props.onCreate()).then(function ($await_3) {
                try {
                  return $If_2.call(this);
                } catch ($boundEx) {
                  return $error($boundEx);
                }
              }.bind(this), $error);
            }

            function $If_2() {
              return $return();
            }

            return $If_2.call(this);
          } catch ($boundEx) {
            return $error($boundEx);
          }
        };var $Try_1_Catch = function (error) {
          try {
            _this.setState(NewBookmark__extends({}, NewBookmark_initialState, { url: url }));
            return $Try_1_Post();
          } catch ($boundEx) {
            return $error($boundEx);
          }
        };try {
          return Promise.resolve(api.post('/bookmark', { url: url })).then(function ($await_4) {
            try {
              _this.setState(NewBookmark__extends({}, NewBookmark_initialState));
              return $Try_1_Post();
            } catch ($boundEx) {
              return $Try_1_Catch($boundEx);
            }
          }, $Try_1_Catch);
        } catch (error) {
          $Try_1_Catch(error)
        }
      });
    }, _temp), NewBookmark__possibleConstructorReturn(_this, _ret);
  }

  /**
   * Misc/helpers
   */

  /**
   * Form
   */


  NewBookmark.prototype.render = function render() {
    var _this2 = this;

    return Object(preact_min["h"])(
      components_Form,
      {
        autocomplete: 'off',
        'class': 'mb-0 mb-sm-1 mb-md-4 mb-lg-4 mb-xl-4',
        onSubmit: function onSubmit() {
          return _this2.submitUrl();
        }
      },
      Object(preact_min["h"])(components_Input, {
        type: 'text',
        placeholder: 'Enter url...',
        value: this.state.url,
        onInput: linkstate_es(this, 'url'),
        'class': inputClass,
        required: true,
        disabled: this.state.loading,
        autocomplete: 'off'
      })
    );
  };

  return NewBookmark;
}(preact_min["Component"]);

/* harmony default export */ var components_NewBookmark = (connect(null, NewBookmark_NewBookmark));
// CONCATENATED MODULE: ./pages/Dashboard.js


function Dashboard__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function Dashboard__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function Dashboard__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var listContainer = {
  minHeight: '400px',
  lineHeight: '400px'
};

var searchInput = {
  // minWidth: '280px',
};

var Dashboard__ref = Object(preact_min["h"])('div', { 'class': 'py-4' });

var Dashboard__ref2 = Object(preact_min["h"])(
  'div',
  { style: listContainer, 'class': 'text-center my-5' },
  'Loading...'
);

var Dashboard__ref3 = Object(preact_min["h"])(
  'div',
  { style: listContainer, 'class': 'text-center my-5' },
  'No bookmarks found.'
);

var Dashboard__ref4 = Object(preact_min["h"])('input', { style: 'opacity: 0;position: absolute;' });

var Dashboard_Dashboard = function (_Component) {
  Dashboard__inherits(Dashboard, _Component);

  function Dashboard() {
    var _temp, _this, _ret;

    Dashboard__classCallCheck(this, Dashboard);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = Dashboard__possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
      bookmarks: [],
      loading: false,
      // Pagination
      currentPage: 1,
      itemsPerPage: 7,
      // Search
      q: ''
    }, _this.findBookmarks = function () {
      var $args = arguments;return new Promise(function ($return, $error) {
        var $Try_1_Finally = function ($Try_1_Exit) {
          return function ($Try_1_Value) {
            try {
              _this.setState({ loading: false });
              return $Try_1_Exit && $Try_1_Exit.call(this, $Try_1_Value);
            } catch ($boundEx) {
              return $error($boundEx);
            }
          }.bind(this);
        }.bind(this);

        var showLoading, bookmarks;
        showLoading = $args.length > 0 && $args[0] !== undefined ? $args[0] : false;

        bookmarks = [];

        if (showLoading) {
          _this.setState({ loading: true });
        }

        var $Try_1_Post = function () {
          try {
            return $return();
          } catch ($boundEx) {
            return $error($boundEx);
          }
        };var $Try_1_Catch = function ($exception_2) {
          try {
            throw $exception_2;
          } catch ($boundEx) {
            return $Try_1_Finally($error)($boundEx);
          }
        };try {
          return Promise.resolve(api.get('/bookmark' + _this.props.url)).then(function ($await_3) {
            try {
              bookmarks = $await_3;

              _this.setState({ bookmarks: bookmarks });
              return $Try_1_Finally($Try_1_Post)();
            } catch ($boundEx) {
              return $Try_1_Catch($boundEx);
            }
          }, $Try_1_Catch);
        } catch ($exception_2) {
          $Try_1_Catch($exception_2)
        }
      });
    }, _this.removeBookmark = function (id) {
      return new Promise(function ($return, $error) {
        return Promise.resolve(api.del('/bookmark/' + id)).then(function ($await_4) {
          try {

            _this.findBookmarks();
            return $return();
          } catch ($boundEx) {
            return $error($boundEx);
          }
        }, $error);
      });
    }, _this.scrollToTop = function () {
      return window.scrollTo(0, 0);
    }, _this.renderPaginator = function () {
      var _this$state = _this.state,
          currentPage = _this$state.currentPage,
          itemsPerPage = _this$state.itemsPerPage,
          bookmarks = _this$state.bookmarks;

      // To few bookmarks

      if (bookmarks.length < itemsPerPage) {
        return Dashboard__ref;
      }

      // If there's nothing else to show
      if (currentPage * itemsPerPage >= bookmarks.length) {
        return Object(preact_min["h"])(
          'div',
          { 'class': 'text-center py-4' },
          Object(preact_min["h"])(
            'div',
            { 'class': 'w-100 text-muted' },
            'all ',
            bookmarks.length,
            ' loaded'
          )
        );
      }

      var showMore = function showMore() {
        return _this.setState({ currentPage: currentPage + 1 });
      };

      return Object(preact_min["h"])(
        'div',
        { 'class': 'text-center py-4' },
        Object(preact_min["h"])(
          'button',
          { 'class': 'w-100 text-muted btn-link', onClick: showMore },
          'show more (',
          bookmarks.length - itemsPerPage,
          ')'
        )
      );
    }, _this.renderList = function () {
      var _this$state2 = _this.state,
          bookmarks = _this$state2.bookmarks,
          loading = _this$state2.loading,
          currentPage = _this$state2.currentPage,
          itemsPerPage = _this$state2.itemsPerPage;


      if (loading) {
        return Dashboard__ref2;
      } else if (!loading && bookmarks.length === 0) {
        return Dashboard__ref3;
      } else if (!loading && bookmarks.length > 0) {
        return Object(preact_min["h"])(
          'div',
          { style: { minHeight: 200 } },
          Object(preact_min["h"])(components_BookmarkList, {
            bookmarks: bookmarks.slice(0, itemsPerPage * currentPage),
            removeBookmark: _this.removeBookmark
          }),
          _this.renderPaginator()
        );
      }
    }, _this.renderSearch = function () {
      var searchBookmarks = function searchBookmarks() {
        return new Promise(function ($return, $error) {
          var q, results;
          return Promise.resolve(_this.findBookmarks()).then(function ($await_5) {
            try {
              q = _this.state.q;


              if (!q) return $return();

              results = _this.state.bookmarks.filter(function (b) {
                var tags = b.tags.map(function (tag) {
                  return tag.name;
                }).join(' ');

                return b.url.includes(q) || b.title.includes(q) || tags.includes(q);
              });

              _this.scrollToTop();

              _this.setState({ bookmarks: results });
              return $return();
            } catch ($boundEx) {
              return $error($boundEx);
            }
          }, $error);
        });
      };

      return Object(preact_min["h"])(
        'div',
        { 'class': 'text-center' },
        Object(preact_min["h"])(
          components_Form,
          { autocomplete: 'off', onSubmit: function onSubmit() {
              return searchBookmarks();
            } },
          Dashboard__ref4,
          Object(preact_min["h"])(components_Input, {
            autocomplete: 'off',
            placeholder: 'Search...',
            value: _this.state.q,
            onInput: linkstate_es(_this, 'q')
          })
        )
      );
    }, _temp), Dashboard__possibleConstructorReturn(_this, _ret);
  }

  Dashboard.prototype.componentDidMount = function componentDidMount() {
    this.findBookmarks(true);
  };

  // User clicked on brand and we should refetch data


  Dashboard.prototype.componentWillReceiveProps = function componentWillReceiveProps() {
    this.findBookmarks(true);

    this.setState({ currentPage: 1 });
  };

  Dashboard.prototype.render = function render() {
    var _state = this.state,
        bookmarks = _state.bookmarks,
        loading = _state.loading;


    var finishedLoading = !loading && bookmarks.length > 0;

    return Object(preact_min["h"])(
      'div',
      null,
      Object(preact_min["h"])(components_NewBookmark, { onCreate: this.findBookmarks }),
      this.renderList(),
      finishedLoading && Object(preact_min["h"])(
        'div',
        { className: 'row mb-5' },
        Object(preact_min["h"])(
          'div',
          { className: 'py-2 col-12' },
          this.renderSearch()
        )
      )
    );
  };

  return Dashboard;
}(preact_min["Component"]);

/* harmony default export */ var pages_Dashboard = (connect('bookmark', Dashboard_Dashboard));
// CONCATENATED MODULE: ./components/Button.js
var Button__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



function Button__objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function Button__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }





// const primaryColor = '#343334'
var primaryColor = '#010033';

var Button_className = dist_default()({
  border: '2px solid ' + primaryColor,
  backgroundColor: primaryColor,
  fontSize: '1em',
  borderRadius: '0',
  cursor: 'pointer',
  color: 'white',
  padding: '0 18px',
  height: '41px',
  ':active': {
    border: '2px solid #6c757d',
    backgroundColor: '#6c757d'
  },
  ':disabled': {
    border: '2px solid #6c757d',
    backgroundColor: '#6c757d'
  }
});

var outlineClass = dist_default()({
  backgroundColor: 'transparent',
  color: primaryColor,
  ':hover': {
    backgroundColor: primaryColor,
    color: '#fff'
  }
});

var Button_Button = function () {
  function Button() {
    Button__classCallCheck(this, Button);
  }

  Button.prototype.render = function render(_ref) {
    var _ref$type = _ref.type,
        type = _ref$type === undefined ? 'button' : _ref$type,
        children = _ref.children,
        _ref$outline = _ref.outline,
        outline = _ref$outline === undefined ? false : _ref$outline,
        rest = Button__objectWithoutProperties(_ref, ['type', 'children', 'outline']);

    return Object(preact_min["h"])(
      'button',
      Button__extends({ type: type }, rest, { 'class': Button_className + ' ' + rest.class + ' ' + (outline && outlineClass) }),
      children
    );
  };

  return Button;
}();

/* harmony default export */ var components_Button = (Button_Button);
// EXTERNAL MODULE: ./assets/screenshot.png
var screenshot = __webpack_require__("hQ5U");
var screenshot_default = /*#__PURE__*/__webpack_require__.n(screenshot);

// CONCATENATED MODULE: ./pages/Landing.js


function Landing__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function Landing__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function Landing__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var ctaButton = {
  height: '2.4em',
  fontSize: '1.4em',
  minWidth: '280px'
};

var headlineStyle = {
  lineHeight: '28px',
  maxWidth: '600px'
};

var Landing__ref = Object(preact_min["h"])(
  'h2',
  null,
  'Minimalistic bookmarking'
);

var Landing__ref2 = Object(preact_min["h"])('img', { 'class': 'img-fluid', src: screenshot_default.a, alt: 'Manter Screenshot' });

var Landing__ref3 = Object(preact_min["h"])(
  'h4',
  { 'class': 'mb-3 text-center' },
  'Own your data'
);

var Landing__ref4 = Object(preact_min["h"])(
  'p',
  { 'class': 'line-h-lg font-lg' },
  'Let\'s keep things between us. Your data will never be shared with anyone. Export and delete things whenever.'
);

var Landing__ref5 = Object(preact_min["h"])(
  'h4',
  { 'class': 'mb-3 text-center' },
  'Plain and simple'
);

var Landing__ref6 = Object(preact_min["h"])(
  'p',
  { 'class': 'line-h-lg font-lg' },
  'No recommendations, sharing, liking or clapping. Manter prizes a clean, simple and lightweight design.'
);

var Landing__ref7 = Object(preact_min["h"])(
  'h4',
  { 'class': 'mb-3 text-center' },
  'Sustainable model'
);

var _ref8 = Object(preact_min["h"])(
  'p',
  { 'class': 'line-h-lg font-lg' },
  'By paying a few dollars a year, you help keeping Manter ad-free and support the development of new features.'
);

var Landing__ref9 = Object(preact_min["h"])(
  'section',
  { id: 'roadmap' },
  Object(preact_min["h"])(
    'div',
    { 'class': 'text-center py-5' },
    Object(preact_min["h"])(
      'h4',
      { 'class': 'font-weight-normal' },
      'Questions? Get in touch by',
      ' ',
      Object(preact_min["h"])(
        'a',
        { 'class': 'text-muted', href: 'mailto:martinelliruan@gmail.com' },
        Object(preact_min["h"])(
          'u',
          null,
          'email'
        )
      ),
      ' ',
      'or send a DM on',
      ' ',
      Object(preact_min["h"])(
        'a',
        { 'class': 'text-muted', href: 'https://twitter.com/manterapp', target: '_blank', rel: 'noopener' },
        Object(preact_min["h"])(
          'u',
          null,
          'twitter'
        )
      ),
      '.'
    ),
    Object(preact_min["h"])(
      'h4',
      { 'class': 'mt-5 font-weight-normal' },
      'See the complete',
      ' ',
      Object(preact_min["h"])(
        'a',
        {
          'class': 'text-muted',
          href: 'https://trello.com/b/ENmnMrxm/manter-roadmap',
          target: '_blank', rel: 'noopener'
        },
        Object(preact_min["h"])(
          'u',
          null,
          'roadmap'
        )
      ),
      ' ',
      'and vote for features.'
    )
  )
);

var Landing_Landing = function (_Component) {
  Landing__inherits(Landing, _Component);

  function Landing() {
    var _temp, _this, _ret;

    Landing__classCallCheck(this, Landing);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = Landing__possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {}, _temp), Landing__possibleConstructorReturn(_this, _ret);
  }

  Landing.prototype.render = function render() {
    return Object(preact_min["h"])(
      'div',
      null,
      Object(preact_min["h"])(
        'section',
        { id: 'cta', 'class': ' mt- -5' },
        Object(preact_min["h"])(
          'div',
          { 'class': 'row' },
          Object(preact_min["h"])(
            'div',
            { 'class': 'col text-center' },
            Landing__ref,
            Object(preact_min["h"])(
              'h5',
              { style: headlineStyle, 'class': 'text-muted my-3 font-weight-normal mx-auto' },
              'Manter is a bookmarking tool for people who value speed, simplicity and control over their data.'
            )
          )
        ),
        Object(preact_min["h"])(
          'div',
          { 'class': 'row mt-4' },
          Object(preact_min["h"])(
            'div',
            { 'class': 'col text-center' },
            Object(preact_min["h"])(
              components_Button,
              { style: ctaButton, 'class': 'd-block m-auto', onClick: function onClick() {
                  return Object(preact_router_es["route"])('/join');
                } },
              'Join for $9 / year',
              ' '
            )
          )
        ),
        Object(preact_min["h"])(
          'div',
          { 'class': 'row' },
          Object(preact_min["h"])(
            'div',
            {
              'class': 'mt-5 mx-5 pt-4 px-4',
              style: { boxShadow: 'rgba(0, 0, 0, 0.1) 0px 0px 24px -2px' }
            },
            Landing__ref2
          )
        )
      ),
      Object(preact_min["h"])(
        'section',
        { id: 'features', 'class': 'mt-5 py-5' },
        Object(preact_min["h"])(
          'div',
          { 'class': 'row' },
          Object(preact_min["h"])(
            'div',
            { 'class': 'col mx-auto', style: { maxWidth: '400px' } },
            Landing__ref3,
            Landing__ref4
          )
        ),
        Object(preact_min["h"])(
          'div',
          { 'class': 'row mt-4' },
          Object(preact_min["h"])(
            'div',
            { 'class': 'col mx-auto', style: { maxWidth: '400px' } },
            Landing__ref5,
            Landing__ref6
          )
        ),
        Object(preact_min["h"])(
          'div',
          { 'class': 'row mt-4' },
          Object(preact_min["h"])(
            'div',
            { 'class': 'col mx-auto', style: { maxWidth: '400px' } },
            Landing__ref7,
            _ref8
          )
        )
      ),
      Landing__ref9,
      Object(preact_min["h"])(
        'section',
        { id: 'cta2' },
        Object(preact_min["h"])(
          'div',
          { 'class': 'text-center py-5 mb-5' },
          Object(preact_min["h"])(
            components_Button,
            { style: ctaButton, 'class': 'd-block m-auto', onClick: function onClick() {
                return Object(preact_router_es["route"])('/join');
              } },
            'Join now'
          )
        )
      )
    );
  };

  return Landing;
}(preact_min["Component"]);

/* harmony default export */ var pages_Landing = (connect(null, Landing_Landing));
// CONCATENATED MODULE: ./components/PrivateRoute.js
var PrivateRoute__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



function PrivateRoute__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function PrivateRoute__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function PrivateRoute__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var PrivateRoute__ref = Object(preact_min["h"])(pages_Landing, null);

var PrivateRoute_PrivateRoute = function (_Component) {
  PrivateRoute__inherits(PrivateRoute, _Component);

  function PrivateRoute() {
    PrivateRoute__classCallCheck(this, PrivateRoute);

    return PrivateRoute__possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  PrivateRoute.prototype.render = function render(props) {
    var component = props.component,
        auth = props.auth;


    if (!auth.accessToken) {
      return PrivateRoute__ref;
    }

    return Object(preact_min["h"])(component, PrivateRoute__extends({}, props));
  };

  return PrivateRoute;
}(preact_min["Component"]);

/* harmony default export */ var components_PrivateRoute = (connect('auth', PrivateRoute_PrivateRoute));
// EXTERNAL MODULE: ../node_modules/lodash.escape/index.js
var lodash_escape = __webpack_require__("WNmI");
var lodash_escape_default = /*#__PURE__*/__webpack_require__.n(lodash_escape);

// CONCATENATED MODULE: ./pages/Settings.js


function Settings__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function Settings__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function Settings__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var bookmarkletStyle = {
  border: '2px dashed gray',
  padding: '8px 15px',
  borderRadius: '15px',
  color: '#6c757d', // text-muted
  textDecoration: 'none'
};

var Settings__ref = Object(preact_min["h"])(
  'h2',
  { 'class': 'mb-5 font-weight-bold' },
  'Settings'
);

var Settings__ref2 = Object(preact_min["h"])(
  'h5',
  { 'class': 'card-title' },
  'Bookmarklet'
);

var Settings__ref3 = Object(preact_min["h"])(
  'p',
  { className: 'card-text mb-5  text-muted' },
  'Drag the button below to your bookmarks bar to save links via bookmarklet.'
);

var Settings__ref4 = Object(preact_min["h"])(
  'h5',
  { 'class': 'card-title' },
  'Export'
);

var Settings__ref5 = Object(preact_min["h"])(
  'p',
  { className: 'card-text text-muted' },
  'Download your data on multiple formats.'
);

var Settings__ref6 = Object(preact_min["h"])(
  'h5',
  { 'class': 'card-title' },
  'Account'
);

var Settings_Settings = function (_Component) {
  Settings__inherits(Settings, _Component);

  function Settings() {
    Settings__classCallCheck(this, Settings);

    var _this = Settings__possibleConstructorReturn(this, _Component.call(this));

    _this.findBookmarks = function () {
      return new Promise(function ($return, $error) {
        var bookmarks;
        return Promise.resolve(api.get('/bookmark')).then(function ($await_1) {
          try {
            bookmarks = $await_1;

            _this.setState({ bookmarks: bookmarks });
            return $return();
          } catch ($boundEx) {
            return $error($boundEx);
          }
        }, $error);
      });
    };

    _this.exportCSV = function () {
      var bookmarks = _this.state.bookmarks;


      var date = new Date().toISOString().substring(0, 10);
      var fileName = date + '-manter-export';

      downloadObjectAsCSV(bookmarks, fileName);
    };

    _this.exportJSON = function () {
      var bookmarks = _this.state.bookmarks;

      var date = new Date().toISOString().substring(0, 10);
      var fileName = date + '-manter-export';

      downloadObjectAsJson(bookmarks, fileName);
    };

    _this.onLogout = _this.onLogout.bind(_this);
    return _this;
  }

  Settings.prototype.componentDidMount = function componentDidMount() {
    this.props.getMe();
    this.findBookmarks();
  };

  Settings.prototype.onLogout = function onLogout() {
    var logout = this.props.logout;


    localStorage.removeItem('unistorePersist');

    logout();

    Object(preact_router_es["route"])('/');
  };

  Settings.prototype.renderBookmarklet = function renderBookmarklet() {
    var baseUrl = 'https://manter.app/submit';
    var bookmarkletUrl = 'javascript:window.location=%22' + baseUrl + '?u=%22+encodeURIComponent(document.location)+%22&t=%22+encodeURIComponent(document.title)';

    return Object(preact_min["h"])(
      'a',
      { 'class': 'cursor-move', style: bookmarkletStyle, rel: 'nofollow', href: lodash_escape_default()(bookmarkletUrl) },
      'Save to Manter'
    );
  };

  Settings.prototype.render = function render() {
    var email = this.props.me.email;


    return Object(preact_min["h"])(
      'div',
      null,
      Settings__ref,
      Object(preact_min["h"])(
        'div',
        { className: 'row d-flex align-items-stretch' },
        Object(preact_min["h"])(
          'div',
          { className: 'col-12 col-md-4 py-2' },
          Object(preact_min["h"])(
            'div',
            { className: 'card card-body h-100' },
            Settings__ref2,
            Settings__ref3,
            Object(preact_min["h"])(
              'div',
              { 'class': 'mt-auto' },
              ' ',
              this.renderBookmarklet()
            )
          )
        ),
        Object(preact_min["h"])(
          'div',
          { className: 'col-12 col-md-4 py-2' },
          Object(preact_min["h"])(
            'div',
            { className: 'card card-body h-100' },
            Settings__ref4,
            Settings__ref5,
            Object(preact_min["h"])(
              'div',
              { 'class': 'mt-auto' },
              Object(preact_min["h"])(
                components_Button,
                { 'class': 'mr-2', onClick: this.exportJSON },
                'JSON'
              ),
              Object(preact_min["h"])(
                components_Button,
                { 'class': 'mr-2', disabled: true, onClick: this.exportCSV },
                'CSV'
              )
            )
          )
        ),
        Object(preact_min["h"])(
          'div',
          { className: 'col-12 col-md-4 py-2' },
          Object(preact_min["h"])(
            'div',
            { className: 'card card-body h-100' },
            Settings__ref6,
            Object(preact_min["h"])(
              'p',
              { className: 'card-text text-muted' },
              'Signed in as ',
              email,
              '.'
            ),
            Object(preact_min["h"])(
              'div',
              { 'class': 'mt-auto' },
              Object(preact_min["h"])(
                components_Button,
                { onClick: this.onLogout },
                'Logout'
              )
            )
          )
        )
      )
    );
  };

  return Settings;
}(preact_min["Component"]);

/* harmony default export */ var pages_Settings = (connect('me', Settings_Settings));
// CONCATENATED MODULE: ./pages/Login.js


function Login__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function Login__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function Login__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var Login__ref = Object(preact_min["h"])(
  'h3',
  { 'class': 'mb-5 text-center' },
  'Log In'
);

var Login__ref2 = Object(preact_min["h"])(
  components_Button,
  { type: 'submit', 'class': 'float-right' },
  'Sign In'
);

var Login__ref3 = Object(preact_min["h"])(
  'div',
  { 'class': 'row' },
  Object(preact_min["h"])(
    'div',
    { 'class': 'col py-5 text-center' },
    Object(preact_min["h"])(
      preact_router_es["Link"],
      { 'class': 'text-muted', href: '/join' },
      'Not a member?'
    ),
    Object(preact_min["h"])(
      'span',
      { 'class': 'mx-3' },
      '|'
    ),
    Object(preact_min["h"])(
      preact_router_es["Link"],
      { 'class': 'text-muted', href: '/forgot' },
      'Forgot password?'
    )
  )
);

var Login_Login = function (_Component) {
  Login__inherits(Login, _Component);

  function Login() {
    var _temp, _this, _ret;

    Login__classCallCheck(this, Login);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = Login__possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
      email: '',
      password: ''
    }, _temp), Login__possibleConstructorReturn(_this, _ret);
  }

  Login.prototype.render = function render(props, state) {
    var login = props.login;
    var email = state.email,
        password = state.password;


    return Object(preact_min["h"])(
      'div',
      null,
      Object(preact_min["h"])(
        'div',
        { 'class': 'row mt-5' },
        Object(preact_min["h"])(
          'div',
          { 'class': 'col-lg-4 col-sm-12 col-xs-12 mx-auto' },
          Login__ref,
          Object(preact_min["h"])(
            components_Form,
            { onSubmit: function onSubmit() {
                return login(email, password);
              } },
            Object(preact_min["h"])(components_Input, {
              label: 'Username or Email',
              value: email,
              type: 'text',
              'class': 'mb-3 w-100',
              required: true,
              onInput: linkstate_es(this, 'email')
            }),
            Object(preact_min["h"])(components_Input, {
              label: 'Password',
              value: password,
              type: 'password',
              'class': 'mb-3 w-100',
              required: true,
              onInput: linkstate_es(this, 'password')
            }),
            Login__ref2
          )
        )
      ),
      Login__ref3
    );
  };

  return Login;
}(preact_min["Component"]);

/* harmony default export */ var pages_Login = (connect(null, Login_Login));
// CONCATENATED MODULE: ./pages/SignUp.js


function SignUp__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function SignUp__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function SignUp__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var SignUp__ref = Object(preact_min["h"])(
  'h3',
  { 'class': 'mb-5 text-center' },
  'Sign Up'
);

var SignUp__ref2 = Object(preact_min["h"])(
  'p',
  null,
  'Welcome!'
);

var SignUp__ref3 = Object(preact_min["h"])(
  components_Button,
  { type: 'submit', 'class': 'float-right d-block' },
  'Sign Up'
);

var SignUp_SignUp = function (_Component) {
  SignUp__inherits(SignUp, _Component);

  function SignUp() {
    var _temp, _this, _ret;

    SignUp__classCallCheck(this, SignUp);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = SignUp__possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
      form: {
        email: '',
        password: '',
        password2: '',
        username: ''
      },
      formSubmitted: false,
      countdown: 5
    }, _this.onFormSubmit = function () {
      return new Promise(function ($return, $error) {
        var _this$state$form, email, password, password2, username, counter;

        _this$state$form = _this.state.form, email = _this$state$form.email, password = _this$state$form.password, password2 = _this$state$form.password2, username = _this$state$form.username;


        if (password !== password2) {
          return $return(react_s_alert_default.a.error('Passwords are different'));
        }

        // Send to API
        return Promise.resolve(_this.props.register({ email: email, password: password, username: username })).then(function ($await_1) {
          try {

            // Replace button with message
            _this.setState({ formSubmitted: true });

            // Redirect in 5 seconds
            setTimeout(function () {
              window.location.replace('https://gumroad.com/l/manter');
            }, 5000);

            // Decrement countdown
            counter = setInterval(function () {
              var countdown = _this.state.countdown;


              if (countdown === 0) return clearInterval(counter);

              _this.setState({ countdown: countdown - 1 });
            }, 1000);
            return $return();
          } catch ($boundEx) {
            return $error($boundEx);
          }
        }, $error);
      });
    }, _temp), SignUp__possibleConstructorReturn(_this, _ret);
  }

  SignUp.prototype.render = function render(_props, state) {
    var _this2 = this;

    var _state$form = state.form,
        email = _state$form.email,
        password = _state$form.password,
        password2 = _state$form.password2,
        username = _state$form.username;
    var formSubmitted = state.formSubmitted,
        countdown = state.countdown;


    return Object(preact_min["h"])(
      'div',
      { 'class': 'row mt-5' },
      Object(preact_min["h"])(
        'div',
        { 'class': 'col-lg-4 col-sm-12 col-xs-12 mx-auto' },
        SignUp__ref,
        Object(preact_min["h"])(
          components_Form,
          { onSubmit: function onSubmit() {
              return _this2.onFormSubmit();
            } },
          Object(preact_min["h"])(components_Input, {
            label: 'Username',
            type: 'text',
            value: username,
            'class': 'mb-3 w-100',
            onInput: linkstate_es(this, 'form.username'),
            required: true
          }),
          Object(preact_min["h"])(components_Input, {
            label: 'Email',
            value: email,
            'class': 'mb-3 w-100',
            onInput: linkstate_es(this, 'form.email'),
            required: true
          }),
          Object(preact_min["h"])(components_Input, {
            label: 'Password',
            type: 'password',
            value: password,
            'class': 'mb-3 w-100',
            onInput: linkstate_es(this, 'form.password'),
            required: true
          }),
          Object(preact_min["h"])(components_Input, {
            label: 'Confirm password',
            type: 'password',
            value: password2,
            'class': 'mb-3 w-100',
            onInput: linkstate_es(this, 'form.password2'),
            required: true
          }),
          formSubmitted ? Object(preact_min["h"])(
            'div',
            { 'class': 'text-center' },
            SignUp__ref2,
            Object(preact_min["h"])(
              'p',
              null,
              'You will be redirect to the payment page in ',
              countdown,
              '...'
            )
          ) : SignUp__ref3
        )
      )
    );
  };

  return SignUp;
}(preact_min["Component"]);

/* harmony default export */ var pages_SignUp = (connect(null, SignUp_SignUp));
// CONCATENATED MODULE: ./pages/NotFound.js


function NotFound__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function NotFound__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function NotFound__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



var NotFound__ref = Object(preact_min["h"])(
  "div",
  { "class": "text-center mt-5 pt-5" },
  Object(preact_min["h"])(
    "h2",
    null,
    "404"
  ),
  "What are you doing?"
);

var NotFound = function (_Component) {
  NotFound__inherits(NotFound, _Component);

  function NotFound() {
    NotFound__classCallCheck(this, NotFound);

    return NotFound__possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  NotFound.prototype.render = function render() {
    return NotFound__ref;
  };

  return NotFound;
}(preact_min["Component"]);


// CONCATENATED MODULE: ./pages/ForgotPassword.js


function ForgotPassword__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function ForgotPassword__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function ForgotPassword__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var ForgotPassword__ref = Object(preact_min["h"])(
  'h3',
  { 'class': 'mb-5' },
  'Reset password'
);

var ForgotPassword__ref2 = Object(preact_min["h"])(
  'div',
  { 'class': 'text-right' },
  Object(preact_min["h"])(
    'p',
    null,
    'Done!'
  ),
  Object(preact_min["h"])(
    'p',
    null,
    'Check your email for instructions'
  )
);

var ForgotPassword__ref3 = Object(preact_min["h"])(
  components_Button,
  { type: 'submit', 'class': 'float-right' },
  'Send reset email'
);

var ForgotPassword_ForgotPassword = function (_Component) {
  ForgotPassword__inherits(ForgotPassword, _Component);

  function ForgotPassword() {
    var _temp, _this, _ret;

    ForgotPassword__classCallCheck(this, ForgotPassword);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = ForgotPassword__possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
      email: '',
      submitted: false
    }, _this.submit = function () {
      return new Promise(function ($return, $error) {
        var email;
        email = _this.state.email;
        return Promise.resolve(api.post('/auth/reset-token', { email: email })).then(function ($await_1) {
          try {

            _this.setState({ submitted: true });
            return $return();
          } catch ($boundEx) {
            return $error($boundEx);
          }
        }, $error);
      });
    }, _temp), ForgotPassword__possibleConstructorReturn(_this, _ret);
  }

  ForgotPassword.prototype.render = function render() {
    var _this2 = this;

    var _state = this.state,
        email = _state.email,
        submitted = _state.submitted;


    return Object(preact_min["h"])(
      'div',
      null,
      ForgotPassword__ref,
      Object(preact_min["h"])(
        components_Form,
        { onSubmit: function onSubmit() {
            return _this2.submit();
          } },
        Object(preact_min["h"])(components_Input, {
          label: 'Email',
          value: email,
          type: 'email',
          'class': 'mb-3 w-100',
          required: true,
          disabled: submitted,
          onInput: linkstate_es(this, 'email')
        }),
        submitted ? ForgotPassword__ref2 : ForgotPassword__ref3
      )
    );
  };

  return ForgotPassword;
}(preact_min["Component"]);

/* harmony default export */ var pages_ForgotPassword = (connect(null, ForgotPassword_ForgotPassword));
// CONCATENATED MODULE: ./pages/ResetPassword.js


function ResetPassword__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function ResetPassword__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function ResetPassword__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }













var ResetPassword__ref = Object(preact_min["h"])(
  'h3',
  { 'class': 'mb-5' },
  'Reset'
);

var ResetPassword__ref2 = Object(preact_min["h"])(
  components_Button,
  { type: 'submit', 'class': 'float-right' },
  'Reset password'
);

var ResetPassword_ResetPassword = function (_Component) {
  ResetPassword__inherits(ResetPassword, _Component);

  function ResetPassword() {
    var _temp, _this, _ret;

    ResetPassword__classCallCheck(this, ResetPassword);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = ResetPassword__possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = { password: null, password2: null }, _this.submit = function () {
      return new Promise(function ($return, $error) {
        var _this$state, password, password2, token;

        _this$state = _this.state, password = _this$state.password, password2 = _this$state.password2;
        token = _this.props.tk;


        if (password !== password2) {
          return $return(react_s_alert_default.a.error('Passwords are different'));
        }

        return Promise.resolve(api.post('/auth/password', { password: password, token: token })).then(function ($await_1) {
          try {

            Object(preact_router_es["route"])('/login');
            return $return();
          } catch ($boundEx) {
            return $error($boundEx);
          }
        }, $error);
      });
    }, _temp), ResetPassword__possibleConstructorReturn(_this, _ret);
  }

  ResetPassword.prototype.render = function render() {
    var _this2 = this;

    var _state = this.state,
        password = _state.password,
        password2 = _state.password2;


    return Object(preact_min["h"])(
      'div',
      null,
      ResetPassword__ref,
      Object(preact_min["h"])(
        components_Form,
        { onSubmit: function onSubmit() {
            return _this2.submit();
          } },
        Object(preact_min["h"])(components_Input, {
          label: 'Password',
          type: 'password',
          value: password,
          'class': 'mb-3 w-100',
          onInput: linkstate_es(this, 'password'),
          required: true
        }),
        Object(preact_min["h"])(components_Input, {
          label: 'Confirm password',
          type: 'password',
          value: password2,
          'class': 'mb-3 w-100',
          onInput: linkstate_es(this, 'password2'),
          required: true
        }),
        ResetPassword__ref2
      )
    );
  };

  return ResetPassword;
}(preact_min["Component"]);

/* harmony default export */ var pages_ResetPassword = (connect(null, ResetPassword_ResetPassword));
// CONCATENATED MODULE: ./pages/Tag.js


function Tag__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function Tag__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function Tag__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var Tag_Tag = function (_Component) {
  Tag__inherits(Tag, _Component);

  function Tag() {
    var _temp, _this, _ret;

    Tag__classCallCheck(this, Tag);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = Tag__possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
      loading: false,
      bookmarks: []
    }, _temp), Tag__possibleConstructorReturn(_this, _ret);
  }

  Tag.prototype.componentDidMount = function componentDidMount() {
    this.findBookmarks();
  };

  Tag.prototype.findBookmarks = function findBookmarks() {
    return new Promise(function ($return, $error) {
      var name, bookmarks;
      name = this.props.name;
      return Promise.resolve(api.get('/bookmark?tags[0]=' + name)).then(function ($await_1) {
        try {

          bookmarks = $await_1;

          this.setState({ bookmarks: bookmarks });
          return $return();
        } catch ($boundEx) {
          return $error($boundEx);
        }
      }.bind(this), $error);
    }.bind(this));
  };

  Tag.prototype.renderList = function renderList() {
    var bookmarks = this.state.bookmarks;


    return bookmarks.map(function (b) {
      return Object(preact_min["h"])(
        'div',
        { 'class': 'row' },
        Object(preact_min["h"])(
          'div',
          { 'class': 'my-2 col' },
          Object(preact_min["h"])(
            'span',
            { 'class': 'mr-2 text-muted' },
            b.relativeTime
          ),
          Object(preact_min["h"])(
            'a',
            { href: b.urlNormalized, 'class': 'text-dark', target: '_blank', rel: 'noopener' },
            b.title
          )
        )
      );
    });
  };

  Tag.prototype.render = function render() {
    var name = this.props.name;
    var bookmarks = this.state.bookmarks;


    return Object(preact_min["h"])(
      'div',
      null,
      Object(preact_min["h"])(
        'h2',
        { 'class': 'font-weight-bold' },
        '#',
        name
      ),
      Object(preact_min["h"])(
        'div',
        { 'class': 'mb-4 text-muted' },
        bookmarks.length > 0 ? bookmarks.length + ' found' : null
      ),
      Object(preact_min["h"])(
        'div',
        { 'class': 'mb-3' },
        this.renderList()
      )
    );
  };

  return Tag;
}(preact_min["Component"]);


// CONCATENATED MODULE: ./pages/Tags.js


function Tags__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function Tags__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function Tags__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var Tags__ref = Object(preact_min["h"])(
  'h2',
  { 'class': 'font-weight-bold' },
  'Tags'
);

var Tags_Tag = function (_Component) {
  Tags__inherits(Tag, _Component);

  function Tag() {
    var _temp, _this, _ret;

    Tags__classCallCheck(this, Tag);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = Tags__possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
      tags: []
    }, _this.findTags = function () {
      return new Promise(function ($return, $error) {
        var tags;
        return Promise.resolve(api.get('/tag')).then(function ($await_1) {
          try {
            tags = $await_1;

            _this.setState({ tags: tags });
            return $return();
          } catch ($boundEx) {
            return $error($boundEx);
          }
        }, $error);
      });
    }, _temp), Tags__possibleConstructorReturn(_this, _ret);
  }

  Tag.prototype.componentDidMount = function componentDidMount() {
    this.findTags();
  };

  Tag.prototype.renderList = function renderList() {
    var tags = this.state.tags;


    return tags.map(function (tag) {
      return Object(preact_min["h"])(
        'div',
        { 'class': 'row' },
        Object(preact_min["h"])(
          'div',
          { 'class': 'col my-2' },
          Object(preact_min["h"])(
            preact_router_es["Link"],
            { 'class': 'text-dark mr-2', href: '/tags/' + tag.name },
            tag.name
          ),
          '(',
          tag.count,
          ')'
        )
      );
    });
  };

  Tag.prototype.render = function render() {
    var tags = this.state.tags;


    return Object(preact_min["h"])(
      'div',
      null,
      Tags__ref,
      Object(preact_min["h"])(
        'div',
        { 'class': 'mb-4 text-muted' },
        tags.length > 0 ? tags.length + ' tags found' : null
      ),
      this.renderList()
    );
  };

  return Tag;
}(preact_min["Component"]);


// CONCATENATED MODULE: ./pages/Submit.js


function Submit__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function Submit__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function Submit__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var Submit__ref = Object(preact_min["h"])(
  'h2',
  { 'class': 'font-weight-bold' },
  'Submit'
);

var Submit__ref2 = Object(preact_min["h"])(
  'div',
  { 'class': 'mb-4 text-muted' },
  'You can also submit via bookmarklet'
);

var Submit__ref3 = Object(preact_min["h"])(
  components_Button,
  { type: 'submit' },
  'Submit'
);

var Submit_Submit = function (_Component) {
  Submit__inherits(Submit, _Component);

  function Submit() {
    var _temp, _this, _ret;

    Submit__classCallCheck(this, Submit);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = Submit__possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
      url: '',
      title: ''
    }, _this.addBookmark = function () {
      return new Promise(function ($return, $error) {
        var _this$state, url, title;

        _this$state = _this.state, url = _this$state.url, title = _this$state.title;
        return Promise.resolve(api.post('/bookmark', { url: url, title: title })).then(function ($await_1) {
          try {

            Object(preact_router_es["route"])('/');
            return $return();
          } catch ($boundEx) {
            return $error($boundEx);
          }
        }, $error);
      });
    }, _temp), Submit__possibleConstructorReturn(_this, _ret);
  }

  Submit.prototype.componentDidMount = function componentDidMount() {
    this.setState({ url: this.props['u'], title: this.props['amp;t'] });
  };

  Submit.prototype.render = function render() {
    var _state = this.state,
        url = _state.url,
        title = _state.title;


    return Object(preact_min["h"])(
      'div',
      null,
      Object(preact_min["h"])(
        'div',
        { className: 'row' },
        Object(preact_min["h"])(
          'div',
          { className: 'col' },
          Submit__ref,
          Submit__ref2,
          Object(preact_min["h"])(
            components_Form,
            { onSubmit: this.addBookmark },
            Object(preact_min["h"])(components_Input, {
              'class': 'w-50 mx-auto mb-4',
              onInput: linkstate_es(this, 'url'),
              value: url,
              label: 'URL',
              required: true
            }),
            Object(preact_min["h"])(components_Input, {
              'class': 'w-50 mx-auto mb-4',
              onInput: linkstate_es(this, 'title'),
              value: title,
              label: 'Title',
              optional: true
            }),
            Submit__ref3
          )
        )
      )
    );
  };

  return Submit;
}(preact_min["Component"]);


// CONCATENATED MODULE: ./components/Footer.js



var Footer__ref = Object(preact_min["h"])(
  "footer",
  null,
  Object(preact_min["h"])(
    "div",
    { "class": "container text-muted " },
    Object(preact_min["h"])(
      "div",
      { className: "row" },
      Object(preact_min["h"])(
        "div",
        { className: "col" },
        Object(preact_min["h"])(
          preact_router_es["Link"],
          { "class": "text-muted mr-4", href: "/terms" },
          "Terms"
        ),
        Object(preact_min["h"])(
          preact_router_es["Link"],
          { "class": "text-muted", href: "/privacy" },
          "Privacy"
        )
      ),
      Object(preact_min["h"])(
        "div",
        { className: "col text-right" },
        "Manter \xA9 2018"
      )
    )
  )
);

var Footer = function Footer() {
  return Footer__ref;
};
// CONCATENATED MODULE: ./pages/Privacy.js


var Privacy__ref = Object(preact_min["h"])(
  "div",
  { "class": "line-h-lg font-lg mb-5 pb-5" },
  Object(preact_min["h"])(
    "h2",
    { "class": "mb-5" },
    "Privacy Policy"
  ),
  Object(preact_min["h"])(
    "p",
    null,
    "Your privacy is important to us. It is Manter's policy to respect your privacy regarding any information we may collect from you across our website,",
    ' ',
    Object(preact_min["h"])(
      "a",
      { "class": "text-muted", href: "https://manter.app" },
      "manter.app"
    ),
    ", and other sites we own and operate.",
    ' '
  ),
  Object(preact_min["h"])(
    "p",
    null,
    "We only ask for personal information when we truly need it to provide a service to you. We collect it by fair and lawful means, with your knowledge and consent. We also let you know why we\u2019re collecting it and how it will be used.",
    ' '
  ),
  Object(preact_min["h"])(
    "p",
    null,
    "We only retain collected information for as long as necessary to provide you with your requested service. What data we store, we\u2019ll protect within commercially acceptable means to prevent loss and theft, as well as unauthorised access, disclosure, copying, use or modification.",
    ' '
  ),
  Object(preact_min["h"])(
    "p",
    null,
    "We don\u2019t share any personally identifying information publicly or with third-parties, except when required to by law.",
    ' '
  ),
  Object(preact_min["h"])(
    "p",
    null,
    "Our website may link to external sites that are not operated by us. Please be aware that we have no control over the content and practices of these sites, and cannot accept responsibility or liability for their respective privacy policies.",
    ' '
  ),
  Object(preact_min["h"])(
    "p",
    null,
    "You are free to refuse our request for your personal information, with the understanding that we may be unable to provide you with some of your desired services.",
    ' '
  ),
  Object(preact_min["h"])(
    "p",
    null,
    "Your continued use of our website will be regarded as acceptance of our practices around privacy and personal information. If you have any questions about how we handle user data and personal information, feel free to contact us.",
    ' '
  ),
  Object(preact_min["h"])(
    "p",
    null,
    "This policy is effective as of 1 November 2018. "
  )
);

var Privacy = function Privacy() {
  return Privacy__ref;
};
// CONCATENATED MODULE: ./pages/Terms.js


var Terms__ref = Object(preact_min["h"])(
  "div",
  { "class": "line-h-lg font-l mb-5 pb-5" },
  Object(preact_min["h"])(
    "h2",
    { "class": "mb-5" },
    "Terms of Service - Manter"
  ),
  Object(preact_min["h"])(
    "h4",
    null,
    "1. Terms"
  ),
  Object(preact_min["h"])(
    "p",
    null,
    "By accessing the website at ",
    Object(preact_min["h"])(
      "a",
      { "class": "text-muted", href: "https://manter.app" },
      "manter.app"
    ),
    ", you are agreeing to be bound by these terms of service, all applicable laws and regulations, and agree that you are responsible for compliance with any applicable local laws. If you do not agree with any of these terms, you are prohibited from using or accessing this site. The materials contained in this website are protected by applicable copyright and trademark law."
  ),
  Object(preact_min["h"])(
    "h4",
    null,
    "2. Use License"
  ),
  Object(preact_min["h"])(
    "ol",
    { type: "a" },
    Object(preact_min["h"])(
      "li",
      null,
      "Permission is granted to temporarily download one copy of the materials (information or software) on Manter's website for personal, non-commercial transitory viewing only. This is the grant of a license, not a transfer of title, and under this license you may not:",
      Object(preact_min["h"])(
        "ol",
        { type: "i" },
        Object(preact_min["h"])(
          "li",
          null,
          "modify or copy the materials;"
        ),
        Object(preact_min["h"])(
          "li",
          null,
          "use the materials for any commercial purpose, or for any public display (commercial or non-commercial);"
        ),
        Object(preact_min["h"])(
          "li",
          null,
          "attempt to decompile or reverse engineer any software contained on Manter's website;"
        ),
        Object(preact_min["h"])(
          "li",
          null,
          "remove any copyright or other proprietary notations from the materials; or"
        ),
        Object(preact_min["h"])(
          "li",
          null,
          "transfer the materials to another person or \"mirror\" the materials on any other server."
        )
      )
    ),
    Object(preact_min["h"])(
      "li",
      null,
      "This license shall automatically terminate if you violate any of these restrictions and may be terminated by Manter at any time. Upon terminating your viewing of these materials or upon the termination of this license, you must destroy any downloaded materials in your possession whether in electronic or printed format."
    )
  ),
  Object(preact_min["h"])(
    "h4",
    null,
    "3. Disclaimer"
  ),
  Object(preact_min["h"])(
    "ol",
    { type: "a" },
    Object(preact_min["h"])(
      "li",
      null,
      "The materials on Manter's website are provided on an 'as is' basis. Manter makes no warranties, expressed or implied, and hereby disclaims and negates all other warranties including, without limitation, implied warranties or conditions of merchantability, fitness for a particular purpose, or non-infringement of intellectual property or other violation of rights."
    ),
    Object(preact_min["h"])(
      "li",
      null,
      "Further, Manter does not warrant or make any representations concerning the accuracy, likely results, or reliability of the use of the materials on its website or otherwise relating to such materials or on any sites linked to this site."
    )
  ),
  Object(preact_min["h"])(
    "h4",
    null,
    "4. Limitations"
  ),
  Object(preact_min["h"])(
    "p",
    null,
    "In no event shall Manter or its suppliers be liable for any damages (including, without limitation, damages for loss of data or profit, or due to business interruption) arising out of the use or inability to use the materials on Manter's website, even if Manter or a Manter authorized representative has been notified orally or in writing of the possibility of such damage. Because some jurisdictions do not allow limitations on implied warranties, or limitations of liability for consequential or incidental damages, these limitations may not apply to you."
  ),
  Object(preact_min["h"])(
    "h4",
    null,
    "5. Accuracy of materials"
  ),
  Object(preact_min["h"])(
    "p",
    null,
    "The materials appearing on Manter's website could include technical, typographical, or photographic errors. Manter does not warrant that any of the materials on its website are accurate, complete or current. Manter may make changes to the materials contained on its website at any time without notice. However Manter does not make any commitment to update the materials."
  ),
  Object(preact_min["h"])(
    "h4",
    null,
    "6. Links"
  ),
  Object(preact_min["h"])(
    "p",
    null,
    "Manter has not reviewed all of the sites linked to its website and is not responsible for the contents of any such linked site. The inclusion of any link does not imply endorsement by Manter of the site. Use of any such linked website is at the user's own risk."
  ),
  Object(preact_min["h"])(
    "h4",
    null,
    "7. Modifications"
  ),
  Object(preact_min["h"])(
    "p",
    null,
    "Manter may revise these terms of service for its website at any time without notice. By using this website you are agreeing to be bound by the then current version of these terms of service."
  ),
  Object(preact_min["h"])(
    "h4",
    null,
    "8. Governing Law"
  ),
  Object(preact_min["h"])(
    "p",
    null,
    "These terms and conditions are governed by and construed in accordance with the laws of Brazil and you irrevocably submit to the exclusive jurisdiction of the courts in that State or location."
  )
);

var Terms = function Terms() {
  return Terms__ref;
};

// Manter Terms of Service

// 1. Terms

//   By accessing the website at http://manter.app, you are agreeing to be bound by these terms of service, all applicable laws and regulations, and agree that you are responsible for compliance with any applicable local laws. If you do not agree with any of these terms, you are prohibited from using or accessing this site. The materials contained in this website are protected by applicable copyright and trademark law.

// 2. Use License

//       Permission is granted to temporarily download one copy of the materials (information or software) on Manter's website for personal, non-commercial transitory viewing only. This is the grant of a license, not a transfer of title, and under this license you may not:

//         modify or copy the materials;
//         use the materials for any commercial purpose, or for any public display (commercial or non-commercial);
//         attempt to decompile or reverse engineer any software contained on Manter's website;
//         remove any copyright or other proprietary notations from the materials; or
//         transfer the materials to another person or "mirror" the materials on any other server.

//     This license shall automatically terminate if you violate any of these restrictions and may be terminated by Manter at any time. Upon terminating your viewing of these materials or upon the termination of this license, you must destroy any downloaded materials in your possession whether in electronic or printed format.

// 3. Disclaimer

//     The materials on Manter's website are provided on an 'as is' basis. Manter makes no warranties, expressed or implied, and hereby disclaims and negates all other warranties including, without limitation, implied warranties or conditions of merchantability, fitness for a particular purpose, or non-infringement of intellectual property or other violation of rights.
//     Further, Manter does not warrant or make any representations concerning the accuracy, likely results, or reliability of the use of the materials on its website or otherwise relating to such materials or on any sites linked to this site.

// 4. Limitations

//   In no event shall Manter or its suppliers be liable for any damages (including, without limitation, damages for loss of data or profit, or due to business interruption) arising out of the use or inability to use the materials on Manter's website, even if Manter or a Manter authorized representative has been notified orally or in writing of the possibility of such damage. Because some jurisdictions do not allow limitations on implied warranties, or limitations of liability for consequential or incidental damages, these limitations may not apply to you.

// 5. Accuracy of materials

//   The materials appearing on Manter's website could include technical, typographical, or photographic errors. Manter does not warrant that any of the materials on its website are accurate, complete or current. Manter may make changes to the materials contained on its website at any time without notice. However Manter does not make any commitment to update the materials.

// 6. Links

//   Manter has not reviewed all of the sites linked to its website and is not responsible for the contents of any such linked site. The inclusion of any link does not imply endorsement by Manter of the site. Use of any such linked website is at the user's own risk.

// 7. Modifications

//   Manter may revise these terms of service for its website at any time without notice. By using this website you are agreeing to be bound by the then current version of these terms of service.

// 8. Governing Law

//   These terms and conditions are governed by and construed in accordance with the laws of Brazil and you irrevocably submit to the exclusive jurisdiction of the courts in that State or location.
// CONCATENATED MODULE: ./Root.js


function Root__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function Root__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function Root__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }



























var Root__ref = Object(preact_min["h"])(components_PrivateRoute, { path: '/', component: pages_Dashboard });

var Root__ref2 = Object(preact_min["h"])(components_PrivateRoute, { path: '/settings', component: pages_Settings });

var Root__ref3 = Object(preact_min["h"])(components_PrivateRoute, { path: '/tags', component: Tags_Tag });

var Root__ref4 = Object(preact_min["h"])(components_PrivateRoute, { path: '/tags/:name', component: Tag_Tag });

var Root__ref5 = Object(preact_min["h"])(components_PrivateRoute, { path: '/submit', component: Submit_Submit });

var Root__ref6 = Object(preact_min["h"])(Terms, { path: '/terms' });

var Root__ref7 = Object(preact_min["h"])(Privacy, { path: '/privacy' });

var Root__ref8 = Object(preact_min["h"])(NotFound, { 'default': true });

var Root__ref9 = Object(preact_min["h"])(pages_Landing, { path: '/' });

var Root__ref10 = Object(preact_min["h"])(pages_Login, { path: '/login' });

var _ref11 = Object(preact_min["h"])(pages_SignUp, { path: '/join' });

var _ref12 = Object(preact_min["h"])(pages_ResetPassword, { path: '/reset' });

var _ref13 = Object(preact_min["h"])(pages_ForgotPassword, { path: '/forgot' });

var _ref14 = Object(preact_min["h"])(Privacy, { path: '/privacy' });

var _ref15 = Object(preact_min["h"])(Terms, { path: '/terms' });

var _ref16 = Object(preact_min["h"])(NotFound, { 'default': true });

var Root_Routes = function () {
  function Routes() {
    var _this = this;

    Root__classCallCheck(this, Routes);

    this.handleRoute = function (e) {
      _this.currentUrl = e.url;
    };
  }

  Routes.prototype.render = function render(props) {
    var isAuth = props.auth && props.auth.accessToken;

    var privateRoutes = [Root__ref, Root__ref2, Root__ref3, Root__ref4, Root__ref5, Root__ref6, Root__ref7, Root__ref8];

    var publicRoutes = [Root__ref9, Root__ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16];

    return Object(preact_min["h"])(
      preact_router_es["Router"],
      { onChange: this.handleRoute },
      isAuth ? privateRoutes : publicRoutes
    );
  };

  return Routes;
}();

var RoutesConnected = connect('auth', Root_Routes);

var _ref17 = Object(preact_min["h"])(Header, null);

var _ref18 = Object(preact_min["h"])(RoutesConnected, null);

var _ref19 = Object(preact_min["h"])(Footer, null);

var Root_Root = function (_Component) {
  Root__inherits(Root, _Component);

  function Root() {
    var _temp, _this2, _ret;

    Root__classCallCheck(this, Root);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this2 = Root__possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this2), _this2.handleRoute = function (e) {
      _this2.currentUrl = e.url;
    }, _temp), Root__possibleConstructorReturn(_this2, _ret);
  }

  Root.prototype.render = function render() {
    return Object(preact_min["h"])(
      preact["Provider"],
      { store: store_0 },
      Object(preact_min["h"])(
        'div',
        { id: 'app' },
        Object(preact_min["h"])(
          'div',
          { 'class': 'wrapper' },
          _ref17,
          Object(preact_min["h"])(
            'main',
            { 'class': 'content container mt-5' },
            _ref18,
            Object(preact_min["h"])(react_s_alert_default.a, { timeout: 5000, stack: { limit: 3 }, html: false, position: 'bottom-right' })
          )
        ),
        _ref19
      )
    );
  };

  return Root;
}(preact_min["Component"]);


// EXTERNAL MODULE: ../node_modules/react-s-alert/dist/s-alert-default.css
var s_alert_default = __webpack_require__("H7e1");
var s_alert_default_default = /*#__PURE__*/__webpack_require__.n(s_alert_default);

// CONCATENATED MODULE: ./index.js






/* harmony default export */ var index_0 = __webpack_exports__["default"] = (Root_Root);

/***/ }),

/***/ "KM04":
/***/ (function(module, exports, __webpack_require__) {

!function () {
  "use strict";
  function e(e, t) {
    var n,
        o,
        r,
        i,
        l = M;for (i = arguments.length; i-- > 2;) {
      T.push(arguments[i]);
    }t && null != t.children && (T.length || T.push(t.children), delete t.children);while (T.length) {
      if ((o = T.pop()) && void 0 !== o.pop) for (i = o.length; i--;) {
        T.push(o[i]);
      } else "boolean" == typeof o && (o = null), (r = "function" != typeof e) && (null == o ? o = "" : "number" == typeof o ? o += "" : "string" != typeof o && (r = !1)), r && n ? l[l.length - 1] += o : l === M ? l = [o] : l.push(o), n = r;
    }var a = new S();return a.nodeName = e, a.children = l, a.attributes = null == t ? void 0 : t, a.key = null == t ? void 0 : t.key, void 0 !== L.vnode && L.vnode(a), a;
  }function t(e, t) {
    for (var n in t) {
      e[n] = t[n];
    }return e;
  }function n(n, o) {
    return e(n.nodeName, t(t({}, n.attributes), o), arguments.length > 2 ? [].slice.call(arguments, 2) : n.children);
  }function o(e) {
    !e.__d && (e.__d = !0) && 1 == D.push(e) && (L.debounceRendering || P)(r);
  }function r() {
    var e,
        t = D;D = [];while (e = t.pop()) {
      e.__d && C(e);
    }
  }function i(e, t, n) {
    return "string" == typeof t || "number" == typeof t ? void 0 !== e.splitText : "string" == typeof t.nodeName ? !e._componentConstructor && l(e, t.nodeName) : n || e._componentConstructor === t.nodeName;
  }function l(e, t) {
    return e.__n === t || e.nodeName.toLowerCase() === t.toLowerCase();
  }function a(e) {
    var n = t({}, e.attributes);n.children = e.children;var o = e.nodeName.defaultProps;if (void 0 !== o) for (var r in o) {
      void 0 === n[r] && (n[r] = o[r]);
    }return n;
  }function p(e, t) {
    var n = t ? document.createElementNS("http://www.w3.org/2000/svg", e) : document.createElement(e);return n.__n = e, n;
  }function s(e) {
    var t = e.parentNode;t && t.removeChild(e);
  }function u(e, t, n, o, r) {
    if ("className" === t && (t = "class"), "key" === t) ;else if ("ref" === t) n && n(null), o && o(e);else if ("class" !== t || r) {
      if ("style" === t) {
        if (o && "string" != typeof o && "string" != typeof n || (e.style.cssText = o || ""), o && "object" == typeof o) {
          if ("string" != typeof n) for (var i in n) {
            i in o || (e.style[i] = "");
          }for (var i in o) {
            e.style[i] = "number" == typeof o[i] && !1 === W.test(i) ? o[i] + "px" : o[i];
          }
        }
      } else if ("dangerouslySetInnerHTML" === t) o && (e.innerHTML = o.__html || "");else if ("o" == t[0] && "n" == t[1]) {
        var l = t !== (t = t.replace(/Capture$/, ""));t = t.toLowerCase().substring(2), o ? n || e.addEventListener(t, c, l) : e.removeEventListener(t, c, l), (e.__l || (e.__l = {}))[t] = o;
      } else if ("list" !== t && "type" !== t && !r && t in e) {
        try {
          e[t] = null == o ? "" : o;
        } catch (e) {}null != o && !1 !== o || "spellcheck" == t || e.removeAttribute(t);
      } else {
        var a = r && t !== (t = t.replace(/^xlink:?/, ""));null == o || !1 === o ? a ? e.removeAttributeNS("http://www.w3.org/1999/xlink", t.toLowerCase()) : e.removeAttribute(t) : "function" != typeof o && (a ? e.setAttributeNS("http://www.w3.org/1999/xlink", t.toLowerCase(), o) : e.setAttribute(t, o));
      }
    } else e.className = o || "";
  }function c(e) {
    return this.__l[e.type](L.event && L.event(e) || e);
  }function _() {
    var e;while (e = E.pop()) {
      L.afterMount && L.afterMount(e), e.componentDidMount && e.componentDidMount();
    }
  }function d(e, t, n, o, r, i) {
    V++ || (A = null != r && void 0 !== r.ownerSVGElement, H = null != e && !("__preactattr_" in e));var l = f(e, t, n, o, i);return r && l.parentNode !== r && r.appendChild(l), --V || (H = !1, i || _()), l;
  }function f(e, t, n, o, r) {
    var i = e,
        a = A;if (null != t && "boolean" != typeof t || (t = ""), "string" == typeof t || "number" == typeof t) return e && void 0 !== e.splitText && e.parentNode && (!e._component || r) ? e.nodeValue != t && (e.nodeValue = t) : (i = document.createTextNode(t), e && (e.parentNode && e.parentNode.replaceChild(i, e), m(e, !0))), i.__preactattr_ = !0, i;var s = t.nodeName;if ("function" == typeof s) return x(e, t, n, o);if (A = "svg" === s || "foreignObject" !== s && A, s += "", (!e || !l(e, s)) && (i = p(s, A), e)) {
      while (e.firstChild) {
        i.appendChild(e.firstChild);
      }e.parentNode && e.parentNode.replaceChild(i, e), m(e, !0);
    }var u = i.firstChild,
        c = i.__preactattr_,
        _ = t.children;if (null == c) {
      c = i.__preactattr_ = {};for (var d = i.attributes, f = d.length; f--;) {
        c[d[f].name] = d[f].value;
      }
    }return !H && _ && 1 === _.length && "string" == typeof _[0] && null != u && void 0 !== u.splitText && null == u.nextSibling ? u.nodeValue != _[0] && (u.nodeValue = _[0]) : (_ && _.length || null != u) && h(i, _, n, o, H || null != c.dangerouslySetInnerHTML), b(i, t.attributes, c), A = a, i;
  }function h(e, t, n, o, r) {
    var l,
        a,
        p,
        u,
        c,
        _ = e.childNodes,
        d = [],
        h = {},
        v = 0,
        b = 0,
        y = _.length,
        g = 0,
        w = t ? t.length : 0;if (0 !== y) for (var C = 0; C < y; C++) {
      var x = _[C],
          N = x.__preactattr_,
          k = w && N ? x._component ? x._component.__k : N.key : null;null != k ? (v++, h[k] = x) : (N || (void 0 !== x.splitText ? !r || x.nodeValue.trim() : r)) && (d[g++] = x);
    }if (0 !== w) for (var C = 0; C < w; C++) {
      u = t[C], c = null;var k = u.key;if (null != k) v && void 0 !== h[k] && (c = h[k], h[k] = void 0, v--);else if (b < g) for (l = b; l < g; l++) {
        if (void 0 !== d[l] && i(a = d[l], u, r)) {
          c = a, d[l] = void 0, l === g - 1 && g--, l === b && b++;break;
        }
      }c = f(c, u, n, o), p = _[C], c && c !== e && c !== p && (null == p ? e.appendChild(c) : c === p.nextSibling ? s(p) : e.insertBefore(c, p));
    }if (v) for (var C in h) {
      void 0 !== h[C] && m(h[C], !1);
    }while (b <= g) {
      void 0 !== (c = d[g--]) && m(c, !1);
    }
  }function m(e, t) {
    var n = e._component;n ? N(n) : (null != e.__preactattr_ && e.__preactattr_.ref && e.__preactattr_.ref(null), !1 !== t && null != e.__preactattr_ || s(e), v(e));
  }function v(e) {
    e = e.lastChild;while (e) {
      var t = e.previousSibling;m(e, !0), e = t;
    }
  }function b(e, t, n) {
    var o;for (o in n) {
      t && null != t[o] || null == n[o] || u(e, o, n[o], n[o] = void 0, A);
    }for (o in t) {
      "children" === o || "innerHTML" === o || o in n && t[o] === ("value" === o || "checked" === o ? e[o] : n[o]) || u(e, o, n[o], n[o] = t[o], A);
    }
  }function y(e, t, n) {
    var o,
        r = B.length;e.prototype && e.prototype.render ? (o = new e(t, n), k.call(o, t, n)) : (o = new k(t, n), o.constructor = e, o.render = g);while (r--) {
      if (B[r].constructor === e) return o.__b = B[r].__b, B.splice(r, 1), o;
    }return o;
  }function g(e, t, n) {
    return this.constructor(e, n);
  }function w(e, t, n, r, i) {
    e.__x || (e.__x = !0, e.__r = t.ref, e.__k = t.key, delete t.ref, delete t.key, void 0 === e.constructor.getDerivedStateFromProps && (!e.base || i ? e.componentWillMount && e.componentWillMount() : e.componentWillReceiveProps && e.componentWillReceiveProps(t, r)), r && r !== e.context && (e.__c || (e.__c = e.context), e.context = r), e.__p || (e.__p = e.props), e.props = t, e.__x = !1, 0 !== n && (1 !== n && !1 === L.syncComponentUpdates && e.base ? o(e) : C(e, 1, i)), e.__r && e.__r(e));
  }function C(e, n, o, r) {
    if (!e.__x) {
      var i,
          l,
          p,
          s = e.props,
          u = e.state,
          c = e.context,
          f = e.__p || s,
          h = e.__s || u,
          v = e.__c || c,
          b = e.base,
          g = e.__b,
          x = b || g,
          k = e._component,
          U = !1,
          S = v;if (e.constructor.getDerivedStateFromProps && (u = t(t({}, u), e.constructor.getDerivedStateFromProps(s, u)), e.state = u), b && (e.props = f, e.state = h, e.context = v, 2 !== n && e.shouldComponentUpdate && !1 === e.shouldComponentUpdate(s, u, c) ? U = !0 : e.componentWillUpdate && e.componentWillUpdate(s, u, c), e.props = s, e.state = u, e.context = c), e.__p = e.__s = e.__c = e.__b = null, e.__d = !1, !U) {
        i = e.render(s, u, c), e.getChildContext && (c = t(t({}, c), e.getChildContext())), b && e.getSnapshotBeforeUpdate && (S = e.getSnapshotBeforeUpdate(f, h));var T,
            M,
            P = i && i.nodeName;if ("function" == typeof P) {
          var W = a(i);l = k, l && l.constructor === P && W.key == l.__k ? w(l, W, 1, c, !1) : (T = l, e._component = l = y(P, W, c), l.__b = l.__b || g, l.__u = e, w(l, W, 0, c, !1), C(l, 1, o, !0)), M = l.base;
        } else p = x, T = k, T && (p = e._component = null), (x || 1 === n) && (p && (p._component = null), M = d(p, i, c, o || !b, x && x.parentNode, !0));if (x && M !== x && l !== k) {
          var D = x.parentNode;D && M !== D && (D.replaceChild(M, x), T || (x._component = null, m(x, !1)));
        }if (T && N(T), e.base = M, M && !r) {
          var A = e,
              H = e;while (H = H.__u) {
            (A = H).base = M;
          }M._component = A, M._componentConstructor = A.constructor;
        }
      }!b || o ? E.unshift(e) : U || (e.componentDidUpdate && e.componentDidUpdate(f, h, S), L.afterUpdate && L.afterUpdate(e));while (e.__h.length) {
        e.__h.pop().call(e);
      }V || r || _();
    }
  }function x(e, t, n, o) {
    var r = e && e._component,
        i = r,
        l = e,
        p = r && e._componentConstructor === t.nodeName,
        s = p,
        u = a(t);while (r && !s && (r = r.__u)) {
      s = r.constructor === t.nodeName;
    }return r && s && (!o || r._component) ? (w(r, u, 3, n, o), e = r.base) : (i && !p && (N(i), e = l = null), r = y(t.nodeName, u, n), e && !r.__b && (r.__b = e, l = null), w(r, u, 1, n, o), e = r.base, l && e !== l && (l._component = null, m(l, !1))), e;
  }function N(e) {
    L.beforeUnmount && L.beforeUnmount(e);var t = e.base;e.__x = !0, e.componentWillUnmount && e.componentWillUnmount(), e.base = null;var n = e._component;n ? N(n) : t && (t.__preactattr_ && t.__preactattr_.ref && t.__preactattr_.ref(null), e.__b = t, s(t), B.push(e), v(t)), e.__r && e.__r(null);
  }function k(e, t) {
    this.__d = !0, this.context = t, this.props = e, this.state = this.state || {}, this.__h = [];
  }function U(e, t, n) {
    return d(n, e, {}, !1, t, !1);
  }var S = function S() {},
      L = {},
      T = [],
      M = [],
      P = "function" == typeof Promise ? Promise.resolve().then.bind(Promise.resolve()) : setTimeout,
      W = /acit|ex(?:s|g|n|p|$)|rph|ows|mnc|ntw|ine[ch]|zoo|^ord/i,
      D = [],
      E = [],
      V = 0,
      A = !1,
      H = !1,
      B = [];t(k.prototype, { setState: function setState(e, n) {
      this.__s || (this.__s = this.state), this.state = t(t({}, this.state), "function" == typeof e ? e(this.state, this.props) : e), n && this.__h.push(n), o(this);
    }, forceUpdate: function forceUpdate(e) {
      e && this.__h.push(e), C(this, 2);
    }, render: function render() {} });var F = { h: e, createElement: e, cloneElement: n, Component: k, render: U, rerender: r, options: L }; true ? module.exports = F : self.preact = F;
}();
//# sourceMappingURL=preact.min.js.map

/***/ }),

/***/ "MUpv":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__("eW0v"), __webpack_require__("5D9O")], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports !== "undefined") {
        factory(exports, require('react'), require('prop-types'));
    } else {
        var mod = {
            exports: {}
        };
        factory(mod.exports, global.react, global.propTypes);
        global.SAlertContentTmpl = mod.exports;
    }
})(this, function (exports, _react, _propTypes) {
    'use strict';

    Object.defineProperty(exports, "__esModule", {
        value: true
    });

    var _react2 = _interopRequireDefault(_react);

    var _propTypes2 = _interopRequireDefault(_propTypes);

    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }

    function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
            throw new TypeError("Cannot call a class as a function");
        }
    }

    var _createClass = function () {
        function defineProperties(target, props) {
            for (var i = 0; i < props.length; i++) {
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor) descriptor.writable = true;
                Object.defineProperty(target, descriptor.key, descriptor);
            }
        }

        return function (Constructor, protoProps, staticProps) {
            if (protoProps) defineProperties(Constructor.prototype, protoProps);
            if (staticProps) defineProperties(Constructor, staticProps);
            return Constructor;
        };
    }();

    function _possibleConstructorReturn(self, call) {
        if (!self) {
            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        }

        return call && (typeof call === "object" || typeof call === "function") ? call : self;
    }

    function _inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) {
            throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
        }

        subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: {
                value: subClass,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
    }

    var SAlertContentTmpl = function (_React$Component) {
        _inherits(SAlertContentTmpl, _React$Component);

        function SAlertContentTmpl(props) {
            _classCallCheck(this, SAlertContentTmpl);

            return _possibleConstructorReturn(this, (SAlertContentTmpl.__proto__ || Object.getPrototypeOf(SAlertContentTmpl)).call(this, props));
        }

        _createClass(SAlertContentTmpl, [{
            key: 'render',
            value: function render() {
                return _react2.default.createElement('div', { className: this.props.classNames, id: this.props.id, style: this.props.styles }, _react2.default.createElement('div', { className: 's-alert-box-inner' }, this.props.message), _react2.default.createElement('span', { className: 's-alert-close', onClick: this.props.handleClose }));
            }
        }]);

        return SAlertContentTmpl;
    }(_react2.default.Component);

    SAlertContentTmpl.propTypes = {
        id: _propTypes2.default.string.isRequired,
        classNames: _propTypes2.default.string.isRequired,
        condition: _propTypes2.default.string.isRequired,
        styles: _propTypes2.default.object.isRequired,
        message: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]).isRequired,
        handleClose: _propTypes2.default.func.isRequired,
        customFields: _propTypes2.default.object
    };

    exports.default = SAlertContentTmpl;
});

/***/ }),

/***/ "QAmr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var index = typeof fetch == 'function' ? fetch.bind() : function (url, options) {
	options = options || {};
	return new Promise(function (resolve, reject) {
		var request = new XMLHttpRequest();

		request.open(options.method || 'get', url, true);

		for (var i in options.headers) {
			request.setRequestHeader(i, options.headers[i]);
		}

		request.withCredentials = options.credentials == 'include';

		request.onload = function () {
			resolve(response());
		};

		request.onerror = reject;

		request.send(options.body || null);

		function response() {
			var _keys = [],
			    all = [],
			    headers = {},
			    header;

			request.getAllResponseHeaders().replace(/^(.*?):[^\S\n]*([\s\S]*?)$/gm, function (m, key, value) {
				_keys.push(key = key.toLowerCase());
				all.push([key, value]);
				header = headers[key];
				headers[key] = header ? header + "," + value : value;
			});

			return {
				ok: (request.status / 100 | 0) == 2, // 200-299
				status: request.status,
				statusText: request.statusText,
				url: request.responseURL,
				clone: response,
				text: function text() {
					return Promise.resolve(request.responseText);
				},
				json: function json() {
					return Promise.resolve(request.responseText).then(JSON.parse);
				},
				blob: function blob() {
					return Promise.resolve(new Blob([request.response]));
				},
				headers: {
					keys: function keys() {
						return _keys;
					},
					entries: function entries() {
						return all;
					},
					get: function get(n) {
						return headers[n.toLowerCase()];
					},
					has: function has(n) {
						return n.toLowerCase() in headers;
					}
				}
			};
		}
	});
};

/* harmony default export */ __webpack_exports__["default"] = (index);
//# sourceMappingURL=unfetch.es.js.map

/***/ }),

/***/ "VYO7":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "65c6eeb61149f289c1e923b9d563f95b.svg";

/***/ }),

/***/ "WNmI":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/** Used to match HTML entities and HTML characters. */
var reUnescapedHtml = /[&<>"'`]/g,
    reHasUnescapedHtml = RegExp(reUnescapedHtml.source);

/** Used to map characters to HTML entities. */
var htmlEscapes = {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  "'": '&#39;',
  '`': '&#96;'
};

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/**
 * The base implementation of `_.propertyOf` without support for deep paths.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyOf(object) {
  return function (key) {
    return object == null ? undefined : object[key];
  };
}

/**
 * Used by `_.escape` to convert characters to HTML entities.
 *
 * @private
 * @param {string} chr The matched character to escape.
 * @returns {string} Returns the escaped character.
 */
var escapeHtmlChar = basePropertyOf(htmlEscapes);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Built-in value references. */
var Symbol = root.Symbol;

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = value + '';
  return result == '0' && 1 / value == -INFINITY ? '-0' : result;
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' || isObjectLike(value) && objectToString.call(value) == symbolTag;
}

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

/**
 * Converts the characters "&", "<", ">", '"', "'", and "\`" in `string` to
 * their corresponding HTML entities.
 *
 * **Note:** No other characters are escaped. To escape additional
 * characters use a third-party library like [_he_](https://mths.be/he).
 *
 * Though the ">" character is escaped for symmetry, characters like
 * ">" and "/" don't need escaping in HTML and have no special meaning
 * unless they're part of a tag or unquoted attribute value. See
 * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
 * (under "semi-related fun fact") for more details.
 *
 * Backticks are escaped because in IE < 9, they can break out of
 * attribute values or HTML comments. See [#59](https://html5sec.org/#59),
 * [#102](https://html5sec.org/#102), [#108](https://html5sec.org/#108), and
 * [#133](https://html5sec.org/#133) of the
 * [HTML5 Security Cheatsheet](https://html5sec.org/) for more details.
 *
 * When working with HTML you should always
 * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
 * XSS vectors.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category String
 * @param {string} [string=''] The string to escape.
 * @returns {string} Returns the escaped string.
 * @example
 *
 * _.escape('fred, barney, & pebbles');
 * // => 'fred, barney, &amp; pebbles'
 */
function escape(string) {
  string = toString(string);
  return string && reHasUnescapedHtml.test(string) ? string.replace(reUnescapedHtml, escapeHtmlChar) : string;
}

module.exports = escape;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("h6ac")))

/***/ }),

/***/ "Zgq/":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports !== "undefined") {
        factory(exports);
    } else {
        var mod = {
            exports: {}
        };
        factory(mod.exports);
        global.sAlertTools = mod.exports;
    }
})(this, function (exports) {
    'use strict';

    Object.defineProperty(exports, "__esModule", {
        value: true
    });

    var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
        return typeof obj;
    } : function (obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };

    var actualGlobalConfig = void 0;

    var sAlertTools = {
        randomId: function randomId() {
            return Math.random().toString(36).split('.')[1];
        },
        returnFirstDefined: function returnFirstDefined() {
            var value = void 0;
            var i = void 0;

            for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
                args[_key] = arguments[_key];
            }

            for (i = 0; i < args.length; i++) {
                if (typeof args[i] !== 'undefined') {
                    value = args[i];
                    break;
                }
            }
            return value;
        },
        styleToObj: function styleToObj(input) {
            var result = {},
                i = void 0,
                entry = void 0,
                attributes = input && input.split(';').filter(Boolean);

            for (i = 0; i < attributes.length; i++) {
                entry = attributes[i].split(':');
                result[entry.splice(0, 1)[0].trim()] = entry.join(':').trim();
            }
            return result;
        },
        setGlobalConfig: function setGlobalConfig(config) {
            if ((typeof config === 'undefined' ? 'undefined' : _typeof(config)) === 'object') {
                actualGlobalConfig = config;
            }
        },
        getGlobalConfig: function getGlobalConfig() {
            return actualGlobalConfig;
        }
    };

    exports.default = sAlertTools;
});

/***/ }),

/***/ "d5YJ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var cache = {};
var prefix = 'x';
var rules = [];
var insert = function insert(rule) {
  return rules.push(rule);
};
var hyph = function hyph(s) {
  return s.replace(/[A-Z]|^ms/g, '-$&').toLowerCase();
};
var mx = function mx(rule, media) {
  return media ? media + '{' + rule + '}' : rule;
};
var rx = function rx(cn, prop, val) {
  return '.' + cn + '{' + hyph(prop) + ':' + val + '}';
};
var noAnd = function noAnd(s) {
  return s.replace(/&/g, '');
};

var parse = function parse(obj) {
  var child = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var media = arguments[2];
  return Object.keys(obj).map(function (key) {
    var val = obj[key];
    if (val === null) return '';
    if (typeof val === 'object') {
      var m2 = /^@/.test(key) ? key : null;
      var c2 = m2 ? child : child + key;
      return parse(val, c2, m2 || media);
    }
    var _key = key + val + child + media;
    if (cache[_key]) return cache[_key];
    var className = prefix + rules.length.toString(36);
    insert(mx(rx(className + noAnd(child), key, val), media));
    cache[_key] = className;
    return className;
  }).join(' ');
};

module.exports = function () {
  for (var _len = arguments.length, styles = Array(_len), _key2 = 0; _key2 < _len; _key2++) {
    styles[_key2] = arguments[_key2];
  }

  return styles.map(function (style) {
    return parse(style);
  }).join(' ').trim();
};

module.exports.css = function () {
  return rules.sort().join('');
};

module.exports.reset = function () {
  cache = {};
  while (rules.length) {
    rules.pop();
  }
};

module.exports.prefix = function (val) {
  return prefix = val;
};

if (typeof document !== 'undefined') {
  var sheet = document.head.appendChild(document.createElement('style')).sheet;
  insert = function insert(rule) {
    rules.push(rule);
    sheet.insertRule(rule, sheet.cssRules.length);
  };
}

/***/ }),

/***/ "e1h4":
/***/ (function(module, exports) {

module.exports = function (t) {
  return t = t || "unistorePersist", { getState: function getState() {
      var e;try {
        e = JSON.parse(localStorage.getItem(t));
      } catch (t) {}if (null !== e) return e;
    }, setState: function setState(e) {
      try {
        localStorage.setItem(t, JSON.stringify(e));
      } catch (t) {}
    }, clearState: function clearState() {
      try {
        localStorage.removeItem(t);
      } catch (t) {}
    } };
};
//# sourceMappingURL=localStorageAdapter.js.map

/***/ }),

/***/ "eW0v":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "version", function() { return version; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DOM", function() { return DOM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Children", function() { return Children; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "render", function() { return render$1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createClass", function() { return createClass; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createPortal", function() { return createPortal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createFactory", function() { return createFactory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createElement", function() { return createElement; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "cloneElement", function() { return cloneElement$1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isValidElement", function() { return isValidElement; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "findDOMNode", function() { return findDOMNode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "unmountComponentAtNode", function() { return unmountComponentAtNode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Component", function() { return Component$1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PureComponent", function() { return PureComponent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "unstable_renderSubtreeIntoContainer", function() { return renderSubtreeIntoContainer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "unstable_batchedUpdates", function() { return unstable_batchedUpdates; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__spread", function() { return extend; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__("5D9O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "PropTypes", function() { return __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_preact__ = __webpack_require__("KM04");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_preact__);




var version = '15.1.0'; // trick libraries to think we are react

var ELEMENTS = 'a abbr address area article aside audio b base bdi bdo big blockquote body br button canvas caption cite code col colgroup data datalist dd del details dfn dialog div dl dt em embed fieldset figcaption figure footer form h1 h2 h3 h4 h5 h6 head header hgroup hr html i iframe img input ins kbd keygen label legend li link main map mark menu menuitem meta meter nav noscript object ol optgroup option output p param picture pre progress q rp rt ruby s samp script section select small source span strong style sub summary sup table tbody td textarea tfoot th thead time title tr track u ul var video wbr circle clipPath defs ellipse g image line linearGradient mask path pattern polygon polyline radialGradient rect stop svg text tspan'.split(' ');

var REACT_ELEMENT_TYPE = typeof Symbol !== 'undefined' && Symbol.for && Symbol.for('react.element') || 0xeac7;

var COMPONENT_WRAPPER_KEY = typeof Symbol !== 'undefined' && Symbol.for ? Symbol.for('__preactCompatWrapper') : '__preactCompatWrapper';

// don't autobind these methods since they already have guaranteed context.
var AUTOBIND_BLACKLIST = {
	constructor: 1,
	render: 1,
	shouldComponentUpdate: 1,
	componentWillReceiveProps: 1,
	componentWillUpdate: 1,
	componentDidUpdate: 1,
	componentWillMount: 1,
	componentDidMount: 1,
	componentWillUnmount: 1,
	componentDidUnmount: 1
};

var CAMEL_PROPS = /^(?:accent|alignment|arabic|baseline|cap|clip|color|fill|flood|font|glyph|horiz|marker|overline|paint|stop|strikethrough|stroke|text|underline|unicode|units|v|vector|vert|word|writing|x)[A-Z]/;

var BYPASS_HOOK = {};

/*global process*/
var DEV = false;
try {
	DEV = "production" !== 'production';
} catch (e) {}

// a component that renders nothing. Used to replace components for unmountComponentAtNode.
function EmptyComponent() {
	return null;
}

// make react think we're react.
var VNode = Object(__WEBPACK_IMPORTED_MODULE_1_preact__["h"])('a', null).constructor;
VNode.prototype.$$typeof = REACT_ELEMENT_TYPE;
VNode.prototype.preactCompatUpgraded = false;
VNode.prototype.preactCompatNormalized = false;

Object.defineProperty(VNode.prototype, 'type', {
	get: function get() {
		return this.nodeName;
	},
	set: function set(v) {
		this.nodeName = v;
	},
	configurable: true
});

Object.defineProperty(VNode.prototype, 'props', {
	get: function get() {
		return this.attributes;
	},
	set: function set(v) {
		this.attributes = v;
	},
	configurable: true
});

var oldEventHook = __WEBPACK_IMPORTED_MODULE_1_preact__["options"].event;
__WEBPACK_IMPORTED_MODULE_1_preact__["options"].event = function (e) {
	if (oldEventHook) {
		e = oldEventHook(e);
	}
	e.persist = Object;
	e.nativeEvent = e;
	return e;
};

var oldVnodeHook = __WEBPACK_IMPORTED_MODULE_1_preact__["options"].vnode;
__WEBPACK_IMPORTED_MODULE_1_preact__["options"].vnode = function (vnode) {
	if (!vnode.preactCompatUpgraded) {
		vnode.preactCompatUpgraded = true;

		var tag = vnode.nodeName,
		    attrs = vnode.attributes = vnode.attributes == null ? {} : extend({}, vnode.attributes);

		if (typeof tag === 'function') {
			if (tag[COMPONENT_WRAPPER_KEY] === true || tag.prototype && 'isReactComponent' in tag.prototype) {
				if (vnode.children && String(vnode.children) === '') {
					vnode.children = undefined;
				}
				if (vnode.children) {
					attrs.children = vnode.children;
				}

				if (!vnode.preactCompatNormalized) {
					normalizeVNode(vnode);
				}
				handleComponentVNode(vnode);
			}
		} else {
			if (vnode.children && String(vnode.children) === '') {
				vnode.children = undefined;
			}
			if (vnode.children) {
				attrs.children = vnode.children;
			}

			if (attrs.defaultValue) {
				if (!attrs.value && attrs.value !== 0) {
					attrs.value = attrs.defaultValue;
				}
				delete attrs.defaultValue;
			}

			handleElementVNode(vnode, attrs);
		}
	}

	if (oldVnodeHook) {
		oldVnodeHook(vnode);
	}
};

function handleComponentVNode(vnode) {
	var tag = vnode.nodeName,
	    a = vnode.attributes;

	vnode.attributes = {};
	if (tag.defaultProps) {
		extend(vnode.attributes, tag.defaultProps);
	}
	if (a) {
		extend(vnode.attributes, a);
	}
}

function handleElementVNode(vnode, a) {
	var shouldSanitize, attrs, i;
	if (a) {
		for (i in a) {
			if (shouldSanitize = CAMEL_PROPS.test(i)) {
				break;
			}
		}
		if (shouldSanitize) {
			attrs = vnode.attributes = {};
			for (i in a) {
				if (a.hasOwnProperty(i)) {
					attrs[CAMEL_PROPS.test(i) ? i.replace(/([A-Z0-9])/, '-$1').toLowerCase() : i] = a[i];
				}
			}
		}
	}
}

// proxy render() since React returns a Component reference.
function render$1(vnode, parent, callback) {
	var prev = parent && parent._preactCompatRendered && parent._preactCompatRendered.base;

	// ignore impossible previous renders
	if (prev && prev.parentNode !== parent) {
		prev = null;
	}

	// default to first Element child
	if (!prev && parent) {
		prev = parent.firstElementChild;
	}

	// remove unaffected siblings
	for (var i = parent.childNodes.length; i--;) {
		if (parent.childNodes[i] !== prev) {
			parent.removeChild(parent.childNodes[i]);
		}
	}

	var out = Object(__WEBPACK_IMPORTED_MODULE_1_preact__["render"])(vnode, parent, prev);
	if (parent) {
		parent._preactCompatRendered = out && (out._component || { base: out });
	}
	if (typeof callback === 'function') {
		callback();
	}
	return out && out._component || out;
}

var ContextProvider = function ContextProvider() {};

ContextProvider.prototype.getChildContext = function () {
	return this.props.context;
};
ContextProvider.prototype.render = function (props) {
	return props.children[0];
};

function renderSubtreeIntoContainer(parentComponent, vnode, container, callback) {
	var wrap = Object(__WEBPACK_IMPORTED_MODULE_1_preact__["h"])(ContextProvider, { context: parentComponent.context }, vnode);
	var renderContainer = render$1(wrap, container);
	var component = renderContainer._component || renderContainer.base;
	if (callback) {
		callback.call(component, renderContainer);
	}
	return component;
}

function Portal(props) {
	renderSubtreeIntoContainer(this, props.vnode, props.container);
}

function createPortal(vnode, container) {
	return Object(__WEBPACK_IMPORTED_MODULE_1_preact__["h"])(Portal, { vnode: vnode, container: container });
}

function unmountComponentAtNode(container) {
	var existing = container._preactCompatRendered && container._preactCompatRendered.base;
	if (existing && existing.parentNode === container) {
		Object(__WEBPACK_IMPORTED_MODULE_1_preact__["render"])(Object(__WEBPACK_IMPORTED_MODULE_1_preact__["h"])(EmptyComponent), container, existing);
		return true;
	}
	return false;
}

var ARR = [];

// This API is completely unnecessary for Preact, so it's basically passthrough.
var Children = {
	map: function map(children, fn, ctx) {
		if (children == null) {
			return null;
		}
		children = Children.toArray(children);
		if (ctx && ctx !== children) {
			fn = fn.bind(ctx);
		}
		return children.map(fn);
	},
	forEach: function forEach(children, fn, ctx) {
		if (children == null) {
			return null;
		}
		children = Children.toArray(children);
		if (ctx && ctx !== children) {
			fn = fn.bind(ctx);
		}
		children.forEach(fn);
	},
	count: function count(children) {
		return children && children.length || 0;
	},
	only: function only(children) {
		children = Children.toArray(children);
		if (children.length !== 1) {
			throw new Error('Children.only() expects only one child.');
		}
		return children[0];
	},
	toArray: function toArray(children) {
		if (children == null) {
			return [];
		}
		return ARR.concat(children);
	}
};

/** Track current render() component for ref assignment */
var currentComponent;

function createFactory(type) {
	return createElement.bind(null, type);
}

var DOM = {};
for (var i = ELEMENTS.length; i--;) {
	DOM[ELEMENTS[i]] = createFactory(ELEMENTS[i]);
}

function upgradeToVNodes(arr, offset) {
	for (var i = offset || 0; i < arr.length; i++) {
		var obj = arr[i];
		if (Array.isArray(obj)) {
			upgradeToVNodes(obj);
		} else if (obj && typeof obj === 'object' && !isValidElement(obj) && (obj.props && obj.type || obj.attributes && obj.nodeName || obj.children)) {
			arr[i] = createElement(obj.type || obj.nodeName, obj.props || obj.attributes, obj.children);
		}
	}
}

function isStatelessComponent(c) {
	return typeof c === 'function' && !(c.prototype && c.prototype.render);
}

// wraps stateless functional components in a PropTypes validator
function wrapStatelessComponent(WrappedComponent) {
	return createClass({
		displayName: WrappedComponent.displayName || WrappedComponent.name,
		render: function render() {
			return WrappedComponent(this.props, this.context);
		}
	});
}

function statelessComponentHook(Ctor) {
	var Wrapped = Ctor[COMPONENT_WRAPPER_KEY];
	if (Wrapped) {
		return Wrapped === true ? Ctor : Wrapped;
	}

	Wrapped = wrapStatelessComponent(Ctor);

	Object.defineProperty(Wrapped, COMPONENT_WRAPPER_KEY, { configurable: true, value: true });
	Wrapped.displayName = Ctor.displayName;
	Wrapped.propTypes = Ctor.propTypes;
	Wrapped.defaultProps = Ctor.defaultProps;

	Object.defineProperty(Ctor, COMPONENT_WRAPPER_KEY, { configurable: true, value: Wrapped });

	return Wrapped;
}

function createElement() {
	var args = [],
	    len = arguments.length;
	while (len--) {
		args[len] = arguments[len];
	}upgradeToVNodes(args, 2);
	return normalizeVNode(__WEBPACK_IMPORTED_MODULE_1_preact__["h"].apply(void 0, args));
}

function normalizeVNode(vnode) {
	vnode.preactCompatNormalized = true;

	applyClassName(vnode);

	if (isStatelessComponent(vnode.nodeName)) {
		vnode.nodeName = statelessComponentHook(vnode.nodeName);
	}

	var ref = vnode.attributes.ref,
	    type = ref && typeof ref;
	if (currentComponent && (type === 'string' || type === 'number')) {
		vnode.attributes.ref = createStringRefProxy(ref, currentComponent);
	}

	applyEventNormalization(vnode);

	return vnode;
}

function cloneElement$1(element, props) {
	var children = [],
	    len = arguments.length - 2;
	while (len-- > 0) {
		children[len] = arguments[len + 2];
	}if (!isValidElement(element)) {
		return element;
	}
	var elementProps = element.attributes || element.props;
	var node = Object(__WEBPACK_IMPORTED_MODULE_1_preact__["h"])(element.nodeName || element.type, extend({}, elementProps), element.children || elementProps && elementProps.children);
	// Only provide the 3rd argument if needed.
	// Arguments 3+ overwrite element.children in preactCloneElement
	var cloneArgs = [node, props];
	if (children && children.length) {
		cloneArgs.push(children);
	} else if (props && props.children) {
		cloneArgs.push(props.children);
	}
	return normalizeVNode(__WEBPACK_IMPORTED_MODULE_1_preact__["cloneElement"].apply(void 0, cloneArgs));
}

function isValidElement(element) {
	return element && (element instanceof VNode || element.$$typeof === REACT_ELEMENT_TYPE);
}

function createStringRefProxy(name, component) {
	return component._refProxies[name] || (component._refProxies[name] = function (resolved) {
		if (component && component.refs) {
			component.refs[name] = resolved;
			if (resolved === null) {
				delete component._refProxies[name];
				component = null;
			}
		}
	});
}

function applyEventNormalization(ref) {
	var nodeName = ref.nodeName;
	var attributes = ref.attributes;

	if (!attributes || typeof nodeName !== 'string') {
		return;
	}
	var props = {};
	for (var i in attributes) {
		props[i.toLowerCase()] = i;
	}
	if (props.ondoubleclick) {
		attributes.ondblclick = attributes[props.ondoubleclick];
		delete attributes[props.ondoubleclick];
	}
	// for *textual inputs* (incl textarea), normalize `onChange` -> `onInput`:
	if (props.onchange && (nodeName === 'textarea' || nodeName.toLowerCase() === 'input' && !/^fil|che|rad/i.test(attributes.type))) {
		var normalized = props.oninput || 'oninput';
		if (!attributes[normalized]) {
			attributes[normalized] = multihook([attributes[normalized], attributes[props.onchange]]);
			delete attributes[props.onchange];
		}
	}
}

function applyClassName(vnode) {
	var a = vnode.attributes || (vnode.attributes = {});
	classNameDescriptor.enumerable = 'className' in a;
	if (a.className) {
		a.class = a.className;
	}
	Object.defineProperty(a, 'className', classNameDescriptor);
}

var classNameDescriptor = {
	configurable: true,
	get: function get() {
		return this.class;
	},
	set: function set(v) {
		this.class = v;
	}
};

function extend(base, props) {
	var arguments$1 = arguments;

	for (var i = 1, obj = void 0; i < arguments.length; i++) {
		if (obj = arguments$1[i]) {
			for (var key in obj) {
				if (obj.hasOwnProperty(key)) {
					base[key] = obj[key];
				}
			}
		}
	}
	return base;
}

function shallowDiffers(a, b) {
	for (var i in a) {
		if (!(i in b)) {
			return true;
		}
	}
	for (var i$1 in b) {
		if (a[i$1] !== b[i$1]) {
			return true;
		}
	}
	return false;
}

function findDOMNode(component) {
	return component && (component.base || component.nodeType === 1 && component) || null;
}

function F() {}

function createClass(obj) {
	function cl(props, context) {
		bindAll(this);
		Component$1.call(this, props, context, BYPASS_HOOK);
		newComponentHook.call(this, props, context);
	}

	obj = extend({ constructor: cl }, obj);

	// We need to apply mixins here so that getDefaultProps is correctly mixed
	if (obj.mixins) {
		applyMixins(obj, collateMixins(obj.mixins));
	}
	if (obj.statics) {
		extend(cl, obj.statics);
	}
	if (obj.propTypes) {
		cl.propTypes = obj.propTypes;
	}
	if (obj.defaultProps) {
		cl.defaultProps = obj.defaultProps;
	}
	if (obj.getDefaultProps) {
		cl.defaultProps = obj.getDefaultProps.call(cl);
	}

	F.prototype = Component$1.prototype;
	cl.prototype = extend(new F(), obj);

	cl.displayName = obj.displayName || 'Component';

	return cl;
}

// Flatten an Array of mixins to a map of method name to mixin implementations
function collateMixins(mixins) {
	var keyed = {};
	for (var i = 0; i < mixins.length; i++) {
		var mixin = mixins[i];
		for (var key in mixin) {
			if (mixin.hasOwnProperty(key) && typeof mixin[key] === 'function') {
				(keyed[key] || (keyed[key] = [])).push(mixin[key]);
			}
		}
	}
	return keyed;
}

// apply a mapping of Arrays of mixin methods to a component prototype
function applyMixins(proto, mixins) {
	for (var key in mixins) {
		if (mixins.hasOwnProperty(key)) {
			proto[key] = multihook(mixins[key].concat(proto[key] || ARR), key === 'getDefaultProps' || key === 'getInitialState' || key === 'getChildContext');
		}
	}
}

function bindAll(ctx) {
	for (var i in ctx) {
		var v = ctx[i];
		if (typeof v === 'function' && !v.__bound && !AUTOBIND_BLACKLIST.hasOwnProperty(i)) {
			(ctx[i] = v.bind(ctx)).__bound = true;
		}
	}
}

function callMethod(ctx, m, args) {
	if (typeof m === 'string') {
		m = ctx.constructor.prototype[m];
	}
	if (typeof m === 'function') {
		return m.apply(ctx, args);
	}
}

function multihook(hooks, skipDuplicates) {
	return function () {
		var arguments$1 = arguments;
		var this$1 = this;

		var ret;
		for (var i = 0; i < hooks.length; i++) {
			var r = callMethod(this$1, hooks[i], arguments$1);

			if (skipDuplicates && r != null) {
				if (!ret) {
					ret = {};
				}
				for (var key in r) {
					if (r.hasOwnProperty(key)) {
						ret[key] = r[key];
					}
				}
			} else if (typeof r !== 'undefined') {
				ret = r;
			}
		}
		return ret;
	};
}

function newComponentHook(props, context) {
	propsHook.call(this, props, context);
	this.componentWillReceiveProps = multihook([propsHook, this.componentWillReceiveProps || 'componentWillReceiveProps']);
	this.render = multihook([propsHook, beforeRender, this.render || 'render', afterRender]);
}

function propsHook(props, context) {
	if (!props) {
		return;
	}

	// React annoyingly special-cases single children, and some react components are ridiculously strict about this.
	var c = props.children;
	if (c && Array.isArray(c) && c.length === 1 && (typeof c[0] === 'string' || typeof c[0] === 'function' || c[0] instanceof VNode)) {
		props.children = c[0];

		// but its totally still going to be an Array.
		if (props.children && typeof props.children === 'object') {
			props.children.length = 1;
			props.children[0] = props.children;
		}
	}

	// add proptype checking
	if (DEV) {
		var ctor = typeof this === 'function' ? this : this.constructor,
		    propTypes = this.propTypes || ctor.propTypes;
		var displayName = this.displayName || ctor.name;

		if (propTypes) {
			__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.checkPropTypes(propTypes, props, 'prop', displayName);
		}
	}
}

function beforeRender(props) {
	currentComponent = this;
}

function afterRender() {
	if (currentComponent === this) {
		currentComponent = null;
	}
}

function Component$1(props, context, opts) {
	__WEBPACK_IMPORTED_MODULE_1_preact__["Component"].call(this, props, context);
	this.state = this.getInitialState ? this.getInitialState() : {};
	this.refs = {};
	this._refProxies = {};
	if (opts !== BYPASS_HOOK) {
		newComponentHook.call(this, props, context);
	}
}
extend(Component$1.prototype = new __WEBPACK_IMPORTED_MODULE_1_preact__["Component"](), {
	constructor: Component$1,

	isReactComponent: {},

	replaceState: function replaceState(state, callback) {
		var this$1 = this;

		this.setState(state, callback);
		for (var i in this$1.state) {
			if (!(i in state)) {
				delete this$1.state[i];
			}
		}
	},

	getDOMNode: function getDOMNode() {
		return this.base;
	},

	isMounted: function isMounted() {
		return !!this.base;
	}
});

function PureComponent(props, context) {
	Component$1.call(this, props, context);
}
F.prototype = Component$1.prototype;
PureComponent.prototype = new F();
PureComponent.prototype.isPureReactComponent = true;
PureComponent.prototype.shouldComponentUpdate = function (props, state) {
	return shallowDiffers(this.props, props) || shallowDiffers(this.state, state);
};

function unstable_batchedUpdates(callback) {
	callback();
}

var index = {
	version: version,
	DOM: DOM,
	PropTypes: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a,
	Children: Children,
	render: render$1,
	createClass: createClass,
	createPortal: createPortal,
	createFactory: createFactory,
	createElement: createElement,
	cloneElement: cloneElement$1,
	isValidElement: isValidElement,
	findDOMNode: findDOMNode,
	unmountComponentAtNode: unmountComponentAtNode,
	Component: Component$1,
	PureComponent: PureComponent,
	unstable_renderSubtreeIntoContainer: renderSubtreeIntoContainer,
	unstable_batchedUpdates: unstable_batchedUpdates,
	__spread: extend
};

/* harmony default export */ __webpack_exports__["default"] = (index);

//# sourceMappingURL=preact-compat.es.js.map

/***/ }),

/***/ "h6ac":
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = function () {
	return this;
}();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1, eval)("this");
} catch (e) {
	// This works if the window reference is available
	if (typeof window === "object") g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;

/***/ }),

/***/ "hQ5U":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "3c790596a0a8f98e4b48b11fa50022b0.png";

/***/ }),

/***/ "hVdT":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("vMuF");

/***/ }),

/***/ "kvQY":
/***/ (function(module, exports) {

module.exports = function unistoreDevTools(store) {
	var extension = window.__REDUX_DEVTOOLS_EXTENSION__ || window.top.__REDUX_DEVTOOLS_EXTENSION__;
	var ignoreState = false;

	if (!extension) {
		console.warn('Please install/enable Redux devtools extension');
		store.devtools = null;

		return store;
	}

	if (!store.devtools) {
		store.devtools = extension.connect();
		store.devtools.subscribe(function (message) {
			if (message.type === 'DISPATCH' && message.state) {
				ignoreState = message.payload.type === 'JUMP_TO_ACTION' || message.payload.type === 'JUMP_TO_STATE';
				store.setState(JSON.parse(message.state), true);
			}
		});
		store.devtools.init(store.getState());
		store.subscribe(function (state, action) {
			var actionName = action && action.name || 'setState';

			if (!ignoreState) {
				store.devtools.send(actionName, state);
			} else {
				ignoreState = false;
			}
		});
	}

	return store;
};

/***/ }),

/***/ "o6ac":
/***/ (function(module, exports, __webpack_require__) {

var t = __webpack_require__("KM04");function n(t, n) {
  for (var r in n) {
    t[r] = n[r];
  }return t;
}function r(t) {
  this.getChildContext = function () {
    return { store: t.store };
  };
}r.prototype.render = function (t) {
  return t.children[0];
}, exports.connect = function (r, e) {
  var o;return "function" != typeof r && ("string" == typeof (o = r || []) && (o = o.split(/\s*,\s*/)), r = function r(t) {
    for (var n = {}, r = 0; r < o.length; r++) {
      n[o[r]] = t[o[r]];
    }return n;
  }), function (o) {
    function i(i, u) {
      var c = this,
          f = u.store,
          s = r(f ? f.getState() : {}, i),
          a = e ? function (t, n) {
        "function" == typeof t && (t = t(n));var r = {};for (var e in t) {
          r[e] = n.action(t[e]);
        }return r;
      }(e, f) : { store: f },
          p = function p() {
        var t = r(f ? f.getState() : {}, c.props);for (var n in t) {
          if (t[n] !== s[n]) return s = t, c.setState(null);
        }for (var e in s) {
          if (!(e in t)) return s = t, c.setState(null);
        }
      };this.componentDidMount = function () {
        f.subscribe(p);
      }, this.componentWillUnmount = function () {
        f.unsubscribe(p);
      }, this.render = function (r) {
        return t.h(o, n(n(n({}, a), r), s));
      };
    }return (i.prototype = new t.Component()).constructor = i;
  };
}, exports.Provider = r;
//# sourceMappingURL=preact.js.map

/***/ }),

/***/ "pwNi":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _preact = __webpack_require__("KM04");

if (false) {
	require('preact/devtools');
} else if (true && 'serviceWorker' in navigator && location.protocol === 'https:') {
	navigator.serviceWorker.register(__webpack_require__.p + 'sw.js');
}

var interopDefault = function interopDefault(m) {
	return m && m.default ? m.default : m;
};

var app = interopDefault(__webpack_require__("JkW7"));

if (typeof app === 'function') {
	var root = document.body.firstElementChild;

	var init = function init() {
		var app = interopDefault(__webpack_require__("JkW7"));
		root = (0, _preact.render)((0, _preact.h)(app), document.body, root);
	};

	if (false) module.hot.accept('preact-cli-entrypoint', init);

	init();
}

/***/ }),

/***/ "sw5u":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.Link = exports.Match = undefined;

var _extends = Object.assign || function (target) {
	for (var i = 1; i < arguments.length; i++) {
		var source = arguments[i];for (var key in source) {
			if (Object.prototype.hasOwnProperty.call(source, key)) {
				target[key] = source[key];
			}
		}
	}return target;
};

var _preact = __webpack_require__("KM04");

var _preactRouter = __webpack_require__("/QC5");

function _objectWithoutProperties(obj, keys) {
	var target = {};for (var i in obj) {
		if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
	}return target;
}

function _classCallCheck(instance, Constructor) {
	if (!(instance instanceof Constructor)) {
		throw new TypeError("Cannot call a class as a function");
	}
}

function _possibleConstructorReturn(self, call) {
	if (!self) {
		throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	}return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
	if (typeof superClass !== "function" && superClass !== null) {
		throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var Match = exports.Match = function (_Component) {
	_inherits(Match, _Component);

	function Match() {
		var _temp, _this, _ret;

		_classCallCheck(this, Match);

		for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
			args[_key] = arguments[_key];
		}

		return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.update = function (url) {
			_this.nextUrl = url;
			_this.setState({});
		}, _temp), _possibleConstructorReturn(_this, _ret);
	}

	Match.prototype.componentDidMount = function componentDidMount() {
		_preactRouter.subscribers.push(this.update);
	};

	Match.prototype.componentWillUnmount = function componentWillUnmount() {
		_preactRouter.subscribers.splice(_preactRouter.subscribers.indexOf(this.update) >>> 0, 1);
	};

	Match.prototype.render = function render(props) {
		var url = this.nextUrl || (0, _preactRouter.getCurrentUrl)(),
		    path = url.replace(/\?.+$/, '');
		this.nextUrl = null;
		return props.children[0] && props.children[0]({
			url: url,
			path: path,
			matches: path === props.path
		});
	};

	return Match;
}(_preact.Component);

var Link = function Link(_ref) {
	var activeClassName = _ref.activeClassName,
	    path = _ref.path,
	    props = _objectWithoutProperties(_ref, ['activeClassName', 'path']);

	return (0, _preact.h)(Match, { path: path || props.href }, function (_ref2) {
		var matches = _ref2.matches;
		return (0, _preact.h)(_preactRouter.Link, _extends({}, props, { 'class': [props.class || props.className, matches && activeClassName].filter(Boolean).join(' ') }));
	});
};

exports.Link = Link;
exports.default = Match;

Match.Link = Link;

/***/ }),

/***/ "tBXR":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "uKgs":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports !== "undefined") {
        factory(exports);
    } else {
        var mod = {
            exports: {}
        };
        factory(mod.exports);
        global.sAlertStore = mod.exports;
    }
})(this, function (exports) {
    'use strict';

    Object.defineProperty(exports, "__esModule", {
        value: true
    });

    function _toConsumableArray(arr) {
        if (Array.isArray(arr)) {
            for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
                arr2[i] = arr[i];
            }

            return arr2;
        } else {
            return Array.from(arr);
        }
    }

    // custom simple store based on a awesome Redux library https://github.com/rackt/redux

    var createSAlertStore = function createSAlertStore(reducer) {
        var state = void 0;
        var listeners = [];
        var getState = function getState() {
            return state;
        };
        var dispatch = function dispatch(action) {
            state = reducer(state, action);
            listeners.forEach(function (listener) {
                return listener();
            });
        };
        var subscribe = function subscribe(listener) {
            listeners.push(listener);
            return function () {
                listeners = listeners.filter(function (l) {
                    return l !== listener;
                });
            };
        };
        dispatch({});
        return {
            getState: getState, dispatch: dispatch, subscribe: subscribe
        };
    };

    var insert = function insert(state, action) {
        return [].concat(_toConsumableArray(state), [action.data]);
    };

    var remove = function remove(state, action) {
        var elemToRemoveArray = state.slice().filter(function (item) {
            return item.id === action.data.id;
        });
        if (Array.isArray(elemToRemoveArray)) {
            var elemToRemoveIndex = state.indexOf(elemToRemoveArray[0]);
            return [].concat(_toConsumableArray(state.slice(0, elemToRemoveIndex)), _toConsumableArray(state.slice(elemToRemoveIndex + 1)));
        }
        return state;
    };

    var alertsReducer = function alertsReducer() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        var action = arguments[1];

        switch (action.type) {
            case 'INSERT':
                return insert(state, action);
            case 'REMOVE':
                return remove(state, action);
            case 'REMOVEALL':
                return [];
            default:
                return state;
        }
    };

    var sAlertStore = createSAlertStore(alertsReducer);

    exports.default = sAlertStore;
});

/***/ }),

/***/ "uVvu":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__("eW0v"), __webpack_require__("eW0v"), __webpack_require__("5D9O"), __webpack_require__("Zgq/"), __webpack_require__("uKgs"), __webpack_require__("MUpv")], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports !== "undefined") {
        factory(exports, require('react'), require('react-dom'), require('prop-types'), require('./s-alert-parts/s-alert-tools'), require('./s-alert-parts/s-alert-store'), require('./SAlertContentTmpl'));
    } else {
        var mod = {
            exports: {}
        };
        factory(mod.exports, global.react, global.reactDom, global.propTypes, global.sAlertTools, global.sAlertStore, global.SAlertContentTmpl);
        global.SAlertContent = mod.exports;
    }
})(this, function (exports, _react, _reactDom, _propTypes, _sAlertTools, _sAlertStore, _SAlertContentTmpl) {
    'use strict';

    Object.defineProperty(exports, "__esModule", {
        value: true
    });

    var _react2 = _interopRequireDefault(_react);

    var _reactDom2 = _interopRequireDefault(_reactDom);

    var _propTypes2 = _interopRequireDefault(_propTypes);

    var _sAlertTools2 = _interopRequireDefault(_sAlertTools);

    var _sAlertStore2 = _interopRequireDefault(_sAlertStore);

    var _SAlertContentTmpl2 = _interopRequireDefault(_SAlertContentTmpl);

    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }

    var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
        return typeof obj;
    } : function (obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };

    function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
            throw new TypeError("Cannot call a class as a function");
        }
    }

    var _createClass = function () {
        function defineProperties(target, props) {
            for (var i = 0; i < props.length; i++) {
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor) descriptor.writable = true;
                Object.defineProperty(target, descriptor.key, descriptor);
            }
        }

        return function (Constructor, protoProps, staticProps) {
            if (protoProps) defineProperties(Constructor.prototype, protoProps);
            if (staticProps) defineProperties(Constructor, staticProps);
            return Constructor;
        };
    }();

    function _possibleConstructorReturn(self, call) {
        if (!self) {
            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        }

        return call && (typeof call === "object" || typeof call === "function") ? call : self;
    }

    function _inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) {
            throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
        }

        subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: {
                value: subClass,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
    }

    var SAlertContent = function (_React$Component) {
        _inherits(SAlertContent, _React$Component);

        function SAlertContent(props) {
            _classCallCheck(this, SAlertContent);

            return _possibleConstructorReturn(this, (SAlertContent.__proto__ || Object.getPrototypeOf(SAlertContent)).call(this, props));
        }

        _createClass(SAlertContent, [{
            key: 'handleCloseAlert',
            value: function handleCloseAlert() {
                var closingTimeout = void 0;
                var alertId = this.props.id;
                var currentAlertElem = _reactDom2.default.findDOMNode(this);
                var animationClose = function animationClose() {
                    currentAlertElem.style.display = 'none';
                    _sAlertStore2.default.dispatch({ type: 'REMOVE', data: { id: alertId } });
                    clearTimeout(closingTimeout);
                };
                if (document.hidden || document.webkitHidden || !currentAlertElem.classList.contains('s-alert-is-effect')) {
                    _sAlertStore2.default.dispatch({ type: 'REMOVE', data: { id: alertId } });
                } else {
                    currentAlertElem.classList.remove('s-alert-show');
                    closingTimeout = setTimeout(function () {
                        currentAlertElem.classList.add('s-alert-hide');
                    }, 100);
                    currentAlertElem.removeEventListener('webkitAnimationEnd', animationClose, false);
                    currentAlertElem.removeEventListener('animationend', animationClose, false);
                    currentAlertElem.addEventListener('webkitAnimationEnd', animationClose, false);
                    currentAlertElem.addEventListener('animationend', animationClose, false);
                }
                // stop audio when closing
                this.alertAudio && this.alertAudio.load();
            }
        }, {
            key: 'componentWillMount',
            value: function componentWillMount() {
                var beep = this.props.beep;
                var condition = this.props.condition;
                if (beep && typeof beep === 'string') {
                    this.alertAudio = new Audio(beep);
                    this.alertAudio.load();
                    this.alertAudio.play();
                }
                if (beep && (typeof beep === 'undefined' ? 'undefined' : _typeof(beep)) === 'object' && condition === 'info') {
                    this.alertAudio = new Audio(beep.info);
                    this.alertAudio.load();
                    this.alertAudio.play();
                }
                if (beep && (typeof beep === 'undefined' ? 'undefined' : _typeof(beep)) === 'object' && condition === 'error') {
                    this.alertAudio = new Audio(beep.error);
                    this.alertAudio.load();
                    this.alertAudio.play();
                }
                if (beep && (typeof beep === 'undefined' ? 'undefined' : _typeof(beep)) === 'object' && condition === 'success') {
                    this.alertAudio = new Audio(beep.success);
                    this.alertAudio.load();
                    this.alertAudio.play();
                }
                if (beep && (typeof beep === 'undefined' ? 'undefined' : _typeof(beep)) === 'object' && condition === 'warning') {
                    this.alertAudio = new Audio(beep.warning);
                    this.alertAudio.load();
                    this.alertAudio.play();
                }
            }
        }, {
            key: 'componentDidMount',
            value: function componentDidMount() {
                var _this2 = this;

                if (typeof this.props.timeout === 'number') {
                    this.closeTimer = setTimeout(function () {
                        _this2.handleCloseAlert();
                    }, this.props.timeout);
                }
                if (this.props.onShow) {
                    this.props.onShow();
                }
            }
        }, {
            key: 'componentWillUnmount',
            value: function componentWillUnmount() {
                if (this.closeTimer) {
                    clearTimeout(this.closeTimer);
                }
                if (this.props.onClose) {
                    this.props.onClose();
                }
            }
        }, {
            key: 'render',
            value: function render() {
                var classNames = 's-alert-box s-alert-' + this.props.condition + ' s-alert-' + this.props.position + ' ' + (this.props.effect ? 's-alert-is-effect s-alert-effect-' + this.props.effect : '') + ' s-alert-show';
                var message = this.props.html ? _react2.default.createElement('span', { dangerouslySetInnerHTML: { __html: this.props.message } }) : this.props.message;
                var styles = this.props.boxPosition ? _sAlertTools2.default.styleToObj(this.props.boxPosition) : {};
                var id = this.props.id;
                var handleClose = this.handleCloseAlert.bind(this);
                var contentTemplate = this.props.contentTemplate || _SAlertContentTmpl2.default;
                var customFields = this.props.customFields || {};
                var condition = this.props.condition;

                return _react2.default.createElement(contentTemplate, { classNames: classNames, id: id, styles: styles, message: message, handleClose: handleClose, customFields: customFields, condition: condition });
            }
        }]);

        return SAlertContent;
    }(_react2.default.Component);

    SAlertContent.propTypes = {
        condition: _propTypes2.default.string.isRequired,
        message: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.node]),
        position: _propTypes2.default.string.isRequired,
        boxPosition: _propTypes2.default.string,
        id: _propTypes2.default.string.isRequired,
        effect: _propTypes2.default.string,
        beep: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object, _propTypes2.default.bool]),
        timeout: _propTypes2.default.oneOfType([_propTypes2.default.oneOf(['none']), _propTypes2.default.number]),
        html: _propTypes2.default.bool,
        onClose: _propTypes2.default.func,
        onShow: _propTypes2.default.func,
        customFields: _propTypes2.default.object,
        contentTemplate: _propTypes2.default.func
    };

    exports.default = SAlertContent;
});

/***/ }),

/***/ "vMuF":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _toConsumableArray(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }return arr2;
  } else {
    return Array.from(arr);
  }
}

var h = __webpack_require__("eW0v").createElement;
var PropTypes = __webpack_require__("5D9O");
var cxs = __webpack_require__("d5YJ");

module.exports = function (C) {
  return function () {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var Comp = function Comp(props) {
      var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var stylePropKeys = [].concat(_toConsumableArray(Object.keys(Comp.propTypes || {})), ['css']);
      var styleProps = _extends({ theme: context.theme || {} }, props);

      var next = {};
      for (var key in props) {
        if (stylePropKeys.includes(key)) continue;
        next[key] = props[key];
      }
      next.className = [next.className].concat(_toConsumableArray(args.map(function (a) {
        return typeof a === 'function' ? a(styleProps) : a;
      }).filter(function (s) {
        return !!s;
      }).map(function (s) {
        return cxs(s);
      })), [cxs(props.css || {})]).join(' ').trim();

      return h(C, next);
    };

    Comp.contextTypes = {
      theme: PropTypes.oneOfType([PropTypes.object, PropTypes.func])
    };

    return Comp;
  };
};

module.exports.css = cxs.css;
module.exports.reset = cxs.reset;

/***/ }),

/***/ "wVGV":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__("Asjh");

function emptyFunction() {}

module.exports = function () {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error('Calling PropTypes validators directly is not supported by the `prop-types` package. ' + 'Use PropTypes.checkPropTypes() to call them. ' + 'Read more at http://fb.me/use-check-prop-types');
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};

/***/ }),

/***/ "zxAs":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("8/ba");

/***/ })

/******/ });


// WEBPACK FOOTER //
// bundle.ef04d.js